"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } } function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var xt=Object.defineProperty,Ja=Object.defineProperties;var Ka=Object.getOwnPropertyDescriptors;var fr=Object.getOwnPropertySymbols;var bt=Object.prototype.hasOwnProperty,ht=Object.prototype.propertyIsEnumerable;var ut=(o,r,e)=>r in o?xt(o,r,{enumerable:!0,configurable:!0,writable:!0,value:e}):o[r]=e,u=(o,r)=>{for(var e in r||(r={}))bt.call(r,e)&&ut(o,e,r[e]);if(fr)for(var e of fr(r))ht.call(r,e)&&ut(o,e,r[e]);return o},Z=(o,r)=>Ja(o,Ka(r));var b=(o,r)=>{var e={};for(var t in o)bt.call(o,t)&&r.indexOf(t)<0&&(e[t]=o[t]);if(o!=null&&fr)for(var t of fr(o))r.indexOf(t)<0&&ht.call(o,t)&&(e[t]=o[t]);return e};var Ra=(o,r)=>{for(var e in r)xt(o,e,{get:r[e],enumerable:!0})};var ur=(o,r,e)=>new Promise((t,n)=>{var i=d=>{try{p(e.next(d))}catch(s){n(s)}},l=d=>{try{p(e.throw(d))}catch(s){n(s)}},p=d=>d.done?t(d.value):Promise.resolve(d.value).then(i,l);p((e=e.apply(o,r)).next())});var _react = require('react'); var _react2 = _interopRequireDefault(_react);function yt(o,r){_react.useEffect.call(void 0, ()=>{function e(t){let n=o.current;!n||n.contains(t.target)||r(t)}return document.addEventListener("mousedown",e),document.addEventListener("touchstart",e),()=>{document.removeEventListener("mousedown",e),document.removeEventListener("touchstart",e)}},[o,r])}function xr(o){function r(e){document.body.classList[e?"add":"remove"]("-no-overflow")}_react.useEffect.call(void 0, ()=>(typeof o=="undefined"&&r(!0),o&&r(!0),()=>{r(!1)}),[o])}var _styledcomponents = require('styled-components'); var _styledcomponents2 = _interopRequireDefault(_styledcomponents);var $t=_styledcomponents.css`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }

  a {
    text-decoration: none;
    color: inherit;
  }
`;var Ct=_styledcomponents.css`
  ${({theme:o})=>_styledcomponents.css`
    p {
      line-height: 160%;
    }

    hr {
      all: unset;

      height: 1px;
      display: block;

      background-color: ${o.colors.grey[100]};
    }

    code {
      background-color: #111;
      border-radius: 3px;
      font-family: courier, monospace;
      padding: 1px 3px;
      color: #fff;
    }

    ul,
    ol {
      line-height: 140%;
      padding-left: ${o.space.md};

      > li {
        &:not(:last-child) {
          margin-bottom: ${o.space.xsm};
        }
      }
    }

    fieldset {
      all: unset;
    }

    pre {
      width: 100%;
      padding: 0;
      margin: 0;
      overflow: auto;
      overflow-y: hidden;
      font-size: 12px;
      line-height: 20px;
      background: #111;
      padding: 10px;
      color: #eee;
      border-radius: ${o.border.radius.sm};
    }

    .nested-navigation-item {
      animation: nested-navigation-item 0.5s;
    }

    @keyframes nested-navigation-item {
      from {
        opacity: 0;
        transform: translateX(10px);
      }

      to {
        opacity: 1;
      }
    }
  `}

  div {
    scroll-margin: 16px;
  }
`;var vt=_styledcomponents.css`
  @keyframes slide-up {
    0% {
      opacity: 0;
      transform: translateY(1rem);
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes slide-down {
    0% {
      opacity: 0;
      transform: translateY(-1rem);
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes slide-left {
    0% {
      opacity: 0;
      transform: translateX(1rem);
    }

    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes slide-right {
    0% {
      opacity: 0;
      transform: translateX(-1rem);
    }

    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes fade-in {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
`;var wt=_styledcomponents.createGlobalStyle`
  ${({theme:o})=>_styledcomponents.css`
    ${$t}
    ${Ct}
    ${vt}

    html {
      scroll-behavior: smooth;
      -webkit-overflow-scrolling: touch;
      font-size: ${o.font.base};
    }

    html,
    body {
      min-height: 100%;
    }

    body {
      overflow-x: hidden;

      color: ${o.font.color.main};
      font-size: ${o.font.size.md};
      font-family: ${o.font.family};

      &.-no-overflow {
        overflow: hidden;
        padding-right: 8px;
      }
    }
  `}
`;function Om({children:o}){return _react2.default.createElement(_styledcomponents.ThemeProvider,{theme:J},_react2.default.createElement(_react2.default.Fragment,null,_react2.default.createElement(wt,null),o))}var Uo={pure:"#FFFFFF",100:"#F0F0F0",200:"#B8B8B8",300:"#CCCCCC"},wo={pure:"#000000",100:"#666666",200:"#3D3D3D",300:"#1F1F1F"},kt={primary:{light:"#DFF1D1",main:"#A6DF7D",dark:"#44A100"},secondary:{lighter:"#CDE7E4",main:"#023932"},info:{light:"#E5f6fd",main:"#03A9F4",dark:"#014361"},warning:{light:"#FFF7DC",main:"#FFB800",dark:"#B98919"},danger:{light:"#F3E4E1",main:"#C66650",dark:"#9D4F3D"},grey:{10:"#FAFAFA",50:"#F6F6F6",80:"#F1F1F1",100:"#EEEDF0",150:"#D6D6D6",200:"#625E5E",main:Uo[100]},white:{main:Uo.pure},black:{main:wo.pure},neutral:{light:Uo[100],main:Uo[200],dark:Uo[300]},neutralDark:{light:wo[100],main:wo[200],dark:wo[300]},overlay:{main:"rgba(0, 0, 0, 0.6)"},purple:{main:"#8A74B8"}};var Pt={family:"'Inter', sans-serif",base:"16px",size:{xsm:"0.625rem",sm:"0.75rem",md:"0.875rem",lg:"1rem",xlg:"1.375rem","2xl":"1.5rem","3xl":"2.125rem"},weight:{xsm:"400",sm:"500",md:"600",lg:"700"},color:{lighter:"#878787",light:wo[100],main:wo[300]}};var It={xsm:"0px 2px 4px rgba(0, 0, 0, 0.1)",sm:"0px 2px 8px rgba(0, 0, 0, 0.1)",md:"0px 2px 16px rgba(0, 0, 0, 0.1)",lg:"0px 2px 24px rgba(0, 0, 0, 0.1)",xlg:"0px 2px 32px rgba(0, 0, 0, 0.1)"};var H=["0px","600px","960px","1280px","1920px"];H.xs=H[0];H.sm=H[1];H.md=H[2];H.lg=H[3];H.xlg=H[4];var Tt={radius:{xsm:"4px",sm:"8px",md:"10px",lg:"12px",xlg:"24px",full:"100%"}};var Mt={xsm:"4px",sm:"8px",md:"16px",lg:"24px",xlg:"32px","2xl":"40px","3xl":"48px"};var Bt={header:100,floating:110,dialog:120,tooltip:130,menu:140};var zt={card:"0px 2px 8px rgba(0, 0, 0, 0.1)"};var At={xs:`@media screen and (min-width: ${H.xs})`,sm:`@media screen and (min-width: ${H.sm})`,md:`@media screen and (min-width: ${H.md})`,lg:`@media screen and (min-width: ${H.lg})`,xl:`@media screen and (min-width: ${H.xl})`};var J={font:Pt,colors:kt,elevations:It,breakpoints:H,mediaQueries:At,border:Tt,space:Mt,layers:Bt,shadows:zt};var M1={};var Ft=_styledcomponents2.default.div`
  ${({theme:o,size:r="xsm",isDisabled:e})=>_styledcomponents.css`
    width: 100%;
    height: ${o.space["2xl"]};
    padding: ${o.space[r]} 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    ${e&&_styledcomponents.css`
      cursor: not-allowed;
    `}
  `}
`,Lt=_styledcomponents2.default.div`
  ${({theme:o,isOpen:r,padding:e="none"})=>_styledcomponents.css`
    overflow: hidden;
    max-height: 0;
    transition: all 0.3s ease-in-out;

    ${e!=="none"&&_styledcomponents.css`
      padding-inline: ${o.space[e]};
    `}

    ${r&&_styledcomponents.css`
      overflow: initial;
      max-height: 9999px;
      margin-bottom: ${o.space.lg};
    `}
  `}
`,Dt=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    & > div:not(:first-child) {
      border-top: 1px solid ${o.colors.grey.main};
    }
  `}
`,Et=_styledcomponents2.default.div`
  ${({theme:o,isOpen:r})=>_styledcomponents.css`
    margin-right: ${o.space.sm};
    rotate: ${r?"0":"180deg"};
    transition: rotate 0.3s ease;
  `}
`;var _t=_react.createContext.call(void 0, {openItems:[],handleOpenedItems:()=>{}}),Ot=_react.createContext.call(void 0, {itemId:-1,isOpen:!1,isDisabled:!1,shouldUnmountContentWhenHide:!1});function Wt(){return _react.useContext.call(void 0, _t)}function No(){return _react.useContext.call(void 0, Ot)}function N1({children:o,size:r,isToggle:e,defaultItems:t,shouldUnmountContentWhenHide:n=!1,padding:i="none"}){let[l,p]=_react.useState.call(void 0, t||[]);_react.useEffect.call(void 0, ()=>{p(t||[])},[t]);let d=s=>{if(l!=null&&l.includes(s))return p(a=>a.filter(m=>m!==s));p(e?[s]:a=>[...a,s])};return _react2.default.createElement(_t.Provider,{value:{openItems:l,handleOpenedItems:d}},_react2.default.createElement(Dt,null,_react.Children.map(o,(s,a)=>{var c,h,f;let m=s.props.expanded===void 0?l==null?void 0:l.includes(a):s.props.expanded;return _react2.default.createElement(Ot.Provider,{value:{itemId:a,isOpen:m,isDisabled:((c=s==null?void 0:s.props)==null?void 0:c.isDisabled)||!1,onChange:(h=s==null?void 0:s.props)==null?void 0:h.onChange,isControlled:((f=s==null?void 0:s.props)==null?void 0:f.expanded)!==void 0,shouldUnmountContentWhenHide:n,size:r,padding:i}},_react2.default.cloneElement(s))})))}var _styledsystem = require('styled-system');var Ss=_styledsystem.compose.call(void 0, _styledsystem.space,_styledsystem.layout,_styledsystem.typography,_styledsystem.color,_styledsystem.flexbox,_styledsystem.border,_styledsystem.background,_styledsystem.grid,_styledsystem.position),Vt=_styledcomponents2.default.div`
  ${({theme:o,spacing:r,onClick:e})=>_styledcomponents.css`
    ${e&&_styledcomponents.css`
      cursor: pointer;
      filter: brightness(90%);
    `}

    ${r&&_styledcomponents.css`
      display: inline-flex;
      flex-wrap: wrap;
      gap: ${o.space[r]};
    `}
  `}

  ${Ss}
`;var x=_react2.default.forwardRef((t,e)=>{var n=t,{children:o}=n,r=b(n,["children"]);return _react2.default.createElement(Vt,u({ref:e},r),o)});function R1({children:o}){let r=_styledcomponents.useTheme.call(void 0, ),{isDisabled:e,padding:t}=No();return _react2.default.createElement(x,null,_react2.default.createElement(x,{display:"flex",bg:e?r.colors.grey[100]:"white",paddingX:t},_react.Children.toArray(o)[0]),_react.Children.toArray(o)[1])}var _outline = require('@heroicons/react/24/outline');function sg({icon:o,iconColor:r="black",children:e}){let{colors:t}=_styledcomponents.useTheme.call(void 0, ),{handleOpenedItems:n}=Wt(),{itemId:i,isOpen:l,isDisabled:p,isControlled:d,onChange:s,size:a}=No(),m=o&&_react.createElement.call(void 0, o,{width:16,height:16,color:t[r].main});return _react2.default.createElement(Ft,{size:a,isDisabled:p,onClick:()=>!p&&!d?n(i):!p&&d&&s?s():void 0},_react2.default.createElement(x,{width:"100%",display:"flex",alignItems:"center",mr:"md"},m&&_react2.default.createElement(x,{display:"flex",alignItems:"center",marginRight:8},m),_react2.default.createElement(x,{width:"100%",fontWeight:700},e)),_react2.default.createElement(Et,{isOpen:l},_react2.default.createElement(_outline.ChevronUpIcon,{width:18})))}function mg({children:o}){let{isOpen:r,shouldUnmountContentWhenHide:e,padding:t}=No();return e&&!r?null:_react2.default.createElement(Lt,{isOpen:r,padding:t},o)}var _solid = require('@heroicons/react/20/solid');var Ts={info:_styledcomponents.css`
    ${({theme:o})=>_styledcomponents.css`
      color: ${o.colors.info.dark};
      background-color: ${o.colors.info.light};
      border-color: ${o.colors.info.main};
    `}
  `,danger:_styledcomponents.css`
    ${({theme:o})=>_styledcomponents.css`
      color: ${o.colors.danger.dark};
      background-color: ${o.colors.danger.light};
      border-color: ${o.colors.danger.main};
    `}
  `,warning:_styledcomponents.css`
    ${({theme:o})=>_styledcomponents.css`
      color: ${o.colors.warning.dark};
      background-color: ${o.colors.warning.light};
      border-color: ${o.colors.warning.main};
    `}
  `,success:_styledcomponents.css`
    ${({theme:o})=>_styledcomponents.css`
      color: ${o.colors.primary.dark};
      background-color: ${o.colors.primary.light};
      border-color: ${o.colors.primary.main};
    `}
  `,neutral:_styledcomponents.css`
    ${({theme:o})=>_styledcomponents.css`
      color: ${o.colors.grey[200]};
      background-color: ${o.colors.grey[80]};
      border-color: ${o.colors.grey[150]};
    `}
  `},qt={isBordered:_styledcomponents.css`
    border: 1px solid transparent;
  `,isFullWidth:_styledcomponents.css`
    width: 100%;
  `},Xt=_styledcomponents2.default.div`
  ${({theme:o,severity:r,padding:e,isBordered:t,isFullWidth:n})=>_styledcomponents.css`
    display: flex;
    align-items: center;
    padding: ${o.space[e]};
    border-radius: ${o.border.radius.sm};
    gap: ${o.space.md};

    ${n&&qt.isFullWidth}
    ${t&&qt.isBordered}
    ${Ts[r]}
  `}
`,Ut=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    width: ${o.font.size.xlg};
    height: ${o.font.size.xlg};
    display: grid;
    place-items: center;

    line-height: 1;
  `}
`,Yt=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    width: 100%;
    word-break: break-word;
    font-size: ${o.font.size.sm};
    font-weight: ${o.font.weight.md};
    color: ${o.font.color.main};
  `}
`,Qt=_styledcomponents2.default.div`
  margin-left: auto;
`,Jt=_styledcomponents2.default.h3.attrs({weight:500,size:"md"})`
  display: block;

  color: inherit;
`;function wg(d){var s=d,{children:o,action:r,hasIcon:e=!0,isBordered:t=!1,isFullWidth:n=!1,severity:i="info",padding:l="md"}=s,p=b(s,["children","action","hasIcon","isBordered","isFullWidth","severity","padding"]);if(!o)return null;function a(){return{success:_react2.default.createElement(_outline.CheckCircleIcon,null),warning:_react2.default.createElement(_outline.ExclamationTriangleIcon,null),danger:_react2.default.createElement(_outline.ExclamationCircleIcon,null),info:_react2.default.createElement(_outline.ExclamationCircleIcon,null),neutral:_react2.default.createElement(_solid.ExclamationCircleIcon,null)}[i||"default"]}return _react2.default.createElement(Xt,u({severity:i,padding:l,isBordered:t,isFullWidth:n},p),e&&_react2.default.createElement(Ut,null,_react2.default.createElement(a,null)),_react2.default.createElement(Yt,null,o),r&&_react2.default.createElement(Qt,null,r))}function Tg({children:o}){return _react2.default.createElement(Jt,null,o)}var _reactportal = require('react-portal');function Ng({alert:o}){return _react2.default.createElement(_reactportal.Portal,null,_react2.default.createElement(oe,{size:"md"},_react2.default.createElement(ie,{onClick:o.onCancel}),_react2.default.createElement(ee,null,_react2.default.createElement(ne,null,_react2.default.createElement("div",null,o.title),_react2.default.createElement(q,{onClick:o.onCancel},_react2.default.createElement(_outline.XMarkIcon,null))),o.description&&_react2.default.createElement(re,null,o.description),_react2.default.createElement(te,null,(o==null?void 0:o.cancelText)&&_react2.default.createElement(j,{isFullWidth:!0,variant:"outlined",color:"white",onClick:o.onCancel,type:"button"},o.cancelText),_react2.default.createElement(j,{isFullWidth:!0,onClick:o.onConfirm,type:"button"},o.confirmText)))))}function _g({title:o,content:r,confirmText:e="Confirmar",cancelText:t="Cancelar",onCancel:n,onConfirm:i,isDisabledConfirm:l=!1}){return _react2.default.createElement(oe,{size:"md"},_react2.default.createElement(ie,{onClick:n}),_react2.default.createElement(ee,null,_react2.default.createElement(ne,null,o),_react2.default.createElement(re,null,r),_react2.default.createElement(te,null,_react2.default.createElement(j,{onClick:n,color:"white"},t),_react2.default.createElement(j,{onClick:i,isDisabled:l},e))))}var on=_styledcomponents2.default.input`
  display: none;
`;var Yg=_react.forwardRef.call(void 0, (g,f)=>{var y=g,{children:o,size:r,color:e,variant:t,isFullWidth:n,isLoading:i,isDisabled:l,loadingText:p,icon:d,id:s,name:a,accept:m,onChange:c}=y,h=b(y,["children","size","color","variant","isFullWidth","isLoading","isDisabled","loadingText","icon","id","name","accept","onChange"]);let[$,D]=_react2.default.useState(),E=()=>{let Y=document.getElementById(s||a);Y&&Y.click()},B=Y=>{let S=Y.target.files;S&&D(S)};return _react2.default.createElement("div",null,_react2.default.createElement(j,{size:r,color:e,variant:t,isFullWidth:n,isLoading:i,isDisabled:l,loadingText:p,icon:d,onClick:E},$&&i?`Anexando ${$==null?void 0:$.length} arquivo(s)...`:$!=null&&$.length?`${$==null?void 0:$.length} arquivo(s) selecionado(s)`:o),_react2.default.createElement(on,u({type:"file",ref:f,id:s||a,accept:m,name:a,onChange:Y=>{B(Y),c&&c(Y)}},h)))});var Ns={sm:_styledcomponents.css`
    width: 32px;
    height: 32px;
    border-radius: ${({theme:o})=>o.border.radius.sm};

    svg {
      height: 12px;
    }
  `,md:_styledcomponents.css`
    width: 48px;
    height: 48px;

    svg {
      height: 24px;
    }
  `,lg:_styledcomponents.css`
    width: 56px;
    height: 56px;

    svg {
      height: 32px;
    }
  `,xlg:_styledcomponents.css`
    width: 80px;
    height: 80px;

    svg {
      height: 40px;
    }
  `},rn=_styledcomponents2.default.div`
  ${({theme:o,size:r,isCircle:e})=>_styledcomponents.css`
    overflow: hidden;
    display: grid;
    place-items: center;
    border: 2px solid ${o.colors.primary.main};

    background-color: ${o.colors.white.main};

    ${Ns[r]}
    ${e?"border-radius: 100px":`border-radius: ${o.border.radius.md}`}
  `}
`,en=_styledcomponents2.default.img`
  width: 100%;
  height: 100%;

  object-fit: cover;
`,tn=_styledcomponents2.default.div`
  line-height: 1;
  color: ${({theme:o})=>o.colors.secondary.main};
`;function tf({size:o="md",src:r,isCircle:e}){return _react2.default.createElement(rn,{size:o,isCircle:e},r?_react2.default.createElement(en,{src:r,loading:"lazy"}):_react2.default.createElement(tn,null,_react2.default.createElement(_outline.UserIcon,null)))}var Zs={default:_styledcomponents.css`
    color: ${({theme:o})=>o.font.color.main};
  `,light:_styledcomponents.css`
    color: ${({theme:o})=>o.font.color.light};
  `,white:_styledcomponents.css`
    color: ${({theme:o})=>o.colors.white.main};
  `,primary:_styledcomponents.css`
    color: ${({theme:o})=>o.colors.primary.main};
  `,secondary:_styledcomponents.css`
    color: ${({theme:o})=>o.colors.secondary.main};
  `,warning:_styledcomponents.css`
    color: ${({theme:o})=>o.colors.warning.main};
  `,danger:_styledcomponents.css`
    color: ${({theme:o})=>o.colors.danger.main};
  `,dangerDark:_styledcomponents.css`
    color: ${({theme:o})=>o.colors.danger.dark};
  `,info:_styledcomponents.css`
    color: ${({theme:o})=>o.colors.info.main};
  `,grey:_styledcomponents.css`
    color: ${({theme:o})=>o.colors.neutral.dark};
  `,warningDark:_styledcomponents.css`
    color: ${({theme:o})=>o.colors.warning.dark};
  `,dark:_styledcomponents.css`
    color: ${({theme:o})=>o.colors.neutralDark};
  `},nn=_styledcomponents2.default.p`
  ${({theme:o,color:r,weight:e,size:t})=>_styledcomponents.css`
    font-weight: ${e};
    font-size: ${o.font.size[t]};

    ${Zs[r]}
  `}

  ${_styledsystem.typography}
`;function v(l){var p=l,{children:o,as:r="p",color:e="default",weight:t=400,size:n="md"}=p,i=b(p,["children","as","color","weight","size"]);return _react2.default.createElement(nn,u({as:r,color:e,size:n,weight:t},i),o)}var Us=o=>({bar:_styledcomponents.css`
    ${({theme:r})=>_styledcomponents.css`
      width: ${r.space[o]};
    `}
  `,circle:_styledcomponents.css`
    ${({theme:r})=>_styledcomponents.css`
      width: ${r.space[o]};
      height: ${r.space[o]};
    `}
  `,"horizontal-bar":_styledcomponents.css`
    ${({theme:r})=>_styledcomponents.css`
      width: ${r.space.md};
      height: ${r.space.sm};
      border-radius: ${r.space.sm};
    `}
  `});function se(o="main"){let r=_styledcomponents.useTheme.call(void 0, );return{primary:r.colors.primary[o],secondary:r.colors.secondary.main,info:r.colors.info[o],warning:r.colors.warning[o],danger:r.colors.danger[o],white:r.colors.white.main,black:r.colors.black.main,grey:r.colors.grey.main,overlay:r.colors.overlay.main,neutral:r.colors.neutral[o],neutralDark:r.colors.neutralDark[o],purple:r.colors.purple.main}}var le=_styledcomponents2.default.div`
  ${({color:o,isFilled:r,hasShadow:e,size:t,marquer:n,colorWeight:i})=>_styledcomponents.css`
    border-radius: 100px;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    ${e&&`box-shadow: 0 0 0 5px ${se(i)[o]}29;`}

    ${r?`background-color: ${se(i)[o]};`:`border: 1px solid ${se(i)[o]};`}

    ${Us(t)[n]}
  `}
`;function an({value:o,color:r="grey",isFilled:e=!0,hasShadow:t=!1,marquer:n="circle",size:i="xsm"}){let l=_styledcomponents.useTheme.call(void 0, ),p=Object.keys(l.colors[r]).includes("light");return _react2.default.createElement(le,{size:i,color:r,colorWeight:n==="circle"&&p&&o?"light":"main",isFilled:e,hasShadow:t,marquer:n},n==="circle"&&o&&_react2.default.createElement(le,{size:Object.keys(l.space)[Object.keys(l.space).indexOf(i)-1],color:r,colorWeight:"main",isFilled:e,marquer:n},_react2.default.createElement(v,{weight:700},o)))}var sn=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    display: flex;
    align-items: center;
    gap: ${o.space.sm};
  `}
`,Cr=_styledcomponents2.default.a`
  ${({theme:o,isLastItem:r})=>_styledcomponents.css`
    display: flex;
    align-items: center;

    cursor: pointer;
    color: ${o.font.color.light};
    font-size: ${o.font.size.md};

    ${!r&&_styledcomponents.css`
      &:hover {
        text-decoration: underline;
      }
    `}

    ${r&&_styledcomponents.css`
      color: ${o.font.color.main};
      font-weight: ${o.font.weight.lg};
    `}
  `}
`,ln=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    margin-left: ${o.space.sm};

    > svg {
      height: 12px;
    }
  `}
`;function pn({items:o}){return o?_react2.default.createElement(sn,null,o.map(({text:r,href:e,onClick:t},n)=>{let i=o.length-1===n;return _react2.default.createElement(Cr,{key:n,href:e,onClick:t,isLastItem:i},r,!i&&_react2.default.createElement(ln,null,_react2.default.createElement(_solid.ChevronRightIcon,null)))})):null}var _polished = require('polished');var rl={xsm:_styledcomponents.css`
    height: 27px;
    padding-inline: 6px;

    font-size: ${({theme:o})=>o.font.size.sm};

    svg {
      width: 12px;
    }
  `,sm:_styledcomponents.css`
    height: 32px;
    padding-inline: 12px;

    font-size: ${({theme:o})=>o.font.size.sm};

    svg {
      width: 16px;
    }
  `,md:_styledcomponents.css`
    height: 40px;
    padding-inline: 12px;

    font-size: ${({theme:o})=>o.font.size.md};

    svg {
      width: 20px;
    }
  `},el=o=>({white:{contained:_styledcomponents.css`
      border-color: ${o.colors.grey[200]};
      background-color: ${o.colors.white.main};
    `,outlined:_styledcomponents.css`
      color: ${o.colors.neutralDark.dark};
      border-color: ${o.colors.neutral.dark};
      background-color: ${o.colors.grey[10]};

      &:hover {
        background-color: ${o.colors.white.main};
      }
    `,text:_styledcomponents.css``},primary:{contained:_styledcomponents.css`
      background-color: ${({theme:r})=>r.colors.primary.main};
    `,outlined:_styledcomponents.css`
      border-color: ${o.colors.primary.main};

      &:hover {
        background-color: ${_polished.rgba.call(void 0, o.colors.primary.main,.1)};
      }
    `,text:_styledcomponents.css``},grey:{contained:_styledcomponents.css`
      color: ${o.colors.white.main};
      border-color: ${o.colors.grey[200]};
      background-color: ${o.colors.grey[200]};
    `,outlined:_styledcomponents.css`
      border-color: ${o.colors.grey[50]};

      &:hover {
        background-color: ${o.colors.white.main};
      }
    `,text:_styledcomponents.css`
      color: ${o.colors.grey[200]};
    `},secondary:{contained:_styledcomponents.css`
      ${({theme:r})=>_styledcomponents.css`
        color: ${r.colors.white.main};
        border-color: ${r.colors.secondary.main};
        background-color: ${r.colors.secondary.main};
      `}
    `,outlined:_styledcomponents.css`
      ${({theme:r})=>_styledcomponents.css`
        border-color: ${r.colors.secondary.main};

        &:hover {
          background-color: ${r.colors.white.main};
        }
      `}
    `,text:_styledcomponents.css`
      color: ${o.colors.secondary.main};
    `},dark:{contained:_styledcomponents.css`
      color: ${o.colors.white.main};
      border-color: ${o.colors.neutralDark.main};
      background-color: ${o.colors.neutralDark.main};
    `,outlined:_styledcomponents.css`
      border-color: ${o.colors.neutralDark.light};

      &:hover {
        background-color: ${o.colors.white.main};
      }
    `,text:_styledcomponents.css`
      color: ${o.colors.neutralDark.main};
    `}}),Ko={isFullWidth:_styledcomponents.css`
    width: 100%;
    justify-content: center;

    text-align: center;
  `,isLoading:_styledcomponents.css`
    opacity: 0.8;
    cursor: not-allowed;
  `,isDisabled:_styledcomponents.css`
    ${({theme:o})=>_styledcomponents.css`
      cursor: not-allowed;
      color: ${o.font.color.lighter};
      background-color: ${o.colors.grey[150]};
    `}
  `,isBordered:_styledcomponents.css`
    border: 1px solid transparent;
  `,text:_styledcomponents.css`
    padding: 0;
    background-color: transparent !important;

    &:hover {
      text-decoration: underline;
    }
  `},dn=_styledcomponents2.default.button`
  ${({theme:o,size:r,color:e,variant:t,disabled:n,isFullWidth:i,isLoading:l,isBordered:p})=>_styledcomponents.css`
    all: unset;

    display: flex;
    align-items: center;
    box-sizing: border-box;
    gap: ${o.space.sm};
    border-radius: ${o.border.radius.sm};

    line-height: 1;
    cursor: pointer;
    transition: all 0.15s;
    color: ${o.colors.secondary.main};
    font-weight: ${o.font.weight.md};

    ${p&&Ko.isBordered}
    ${rl[r]}
    ${el(o)[e][t]}
    ${l&&Ko.isLoading}
    ${n&&Ko.isDisabled}
    ${t==="text"&&Ko.text}
    ${i&&Ko.isFullWidth}

    &:hover {
      transition: all 0.15s;

      filter: brightness(96%);
    }
  `}
`;var j=_react.forwardRef.call(void 0, (c,m)=>{var h=c,{children:o,icon:r,loadingText:e,size:t="md",color:n="primary",variant:i="contained",isDisabled:l,isLoading:p=!1,isBordered:d=!0,iconSide:s="left"}=h,a=b(h,["children","icon","loadingText","size","color","variant","isDisabled","isLoading","isBordered","iconSide"]);return _react2.default.createElement(dn,Z(u({},a),{ref:m,size:t,color:n,variant:i,disabled:l||p,isLoading:p,isBordered:d}),r&&s==="left"&&!p&&r,p&&_react2.default.createElement(so,{size:"sm",color:"secondary"}),p&&e?e:o,r&&s==="right"&&r)});var ce={isFullWidth:_styledcomponents.css`
    width: 100%;
    display: block;
  `,isBorderer:_styledcomponents.css`
    border: 1px solid;
    border-color: ${({theme:o})=>o.colors.grey[150]};
  `},ge=_styledcomponents2.default.div`
  ${({color:o,elevation:r,textColor:e,theme:t,isFullWidth:n,isBordered:i,border:l,borderRadius:p,borderColor:d,isColorLighten:s})=>{var a;return _styledcomponents.css`
    display: inline-block;
    border-radius: ${p!=="none"&&t.border.radius[p]};

    background-color: ${s?`${t.colors[o].main}17`:t.colors[o].main};
    color: ${t.colors[e].main};
    ${n&&ce.isFullWidth}
    ${i&&ce.isBorderer}
    ${r&&`box-shadow: ${t.elevations[r]};`}
    ${l&&`border: ${l} ${(a=t.colors[d])==null?void 0:a.main};`}
    ${_styledsystem.space}
  `}}
`,mn=_styledcomponents2.default.div`
  ${({theme:o,isFullWidth:r,isBordered:e})=>_styledcomponents.css`
    display: inline-block;

    & > div:first-child:not(:last-child) {
      border-radius: ${o.border.radius.md} ${o.border.radius.md} 0 0;

      ${e&&_styledcomponents.css`
        border-bottom: 2px solid ${o.colors.white.main};
      `}
    }

    & > div:not(:first-child) {
      border-radius: 0;
      border: 0;

      ${e&&_styledcomponents.css`
        border-bottom: 2px solid ${o.colors.white.main};
      `}
    }

    & > div:last-child:not(:first-child) {
      border-radius: 0 0 ${o.border.radius.md} ${o.border.radius.md};
    }

    ${r&&ce.isFullWidth}
  `}
`,gn=_styledcomponents2.default.call(void 0, ge)`
  ${({theme:o})=>_styledcomponents.css`
    border-radius: ${o.border.radius.md} ${o.border.radius.md} 0 0;
    border-bottom: 0;

    padding: ${o.space.xsm} ${o.space.md};
    margin: 0 ${o.space.sm};

    display: block;
    width: fit-content;
  `}
`;function X(c){var h=c,{children:o,title:r,elevation:e,group:t=!1,color:n="white",textColor:i="black",padding:l="md",isFullWidth:p=!0,isBordered:d=!1,borderRadius:s="md",isColorLighten:a=!1}=h,m=b(h,["children","title","elevation","group","color","textColor","padding","isFullWidth","isBordered","borderRadius","isColorLighten"]);return t?_react2.default.createElement(x,{minWidth:"fit-content"},r&&_react2.default.createElement(gn,{color:n,isColorLighten:a,textColor:i,isBordered:d},_react2.default.createElement(v,{size:"sm",weight:700},r)),_react2.default.createElement(mn,{isFullWidth:p,isBordered:d},o)):_react2.default.createElement(ge,u({color:n,elevation:e,isColorLighten:a,textColor:i,padding:l,isFullWidth:p,isBordered:d,borderRadius:s},m),o)}var _styledmediaquery = require('styled-media-query'); var _styledmediaquery2 = _interopRequireDefault(_styledmediaquery);var pl=_styledcomponents.css`
  ${({theme:o})=>_styledsystem.variant.call(void 0, {prop:"variant",variants:{sm:{fontWeight:o.font.weight.md,fontSize:o.font.size.md},md:{fontWeight:o.font.weight.lg,fontSize:o.font.size.lg}}})}
`,fn=_styledcomponents2.default.p`
  color: ${({theme:o})=>o.font.color.main};
  line-height: 100%;

  ${pl}
`,un=_styledcomponents2.default.div`
  ${({theme:o,hasIndentation:r,spacing:e,hasCentralize:t})=>_styledcomponents.css`
    width: 100%;
    margin-bottom: ${e!=="none"&&o.space[e]};
    display: flex;
    align-items: center;
    justify-content: ${t?"center":"space-between"};
    gap: ${o.space.sm};

    ${r&&_styledcomponents.css`
      margin-top: ${o.space.sm};
      padding-inline: ${o.space.sm};
    `}

    ${_styledmediaquery2.default.lessThan("medium")`
      flex-direction: column;
      align-items: flex-start;
    `}
  `}
`,fe=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    display: flex;
    align-items: center;
    gap: ${o.space.sm};
    color: ${o.font.color.main};

    svg {
      width: ${o.font.size.lg};
      height: ${o.font.size.lg};
      stroke-width: 2px;
    }
  `}
`,xn=_styledcomponents2.default.div`
  font-size: ${({theme:o})=>o.font.size.sm};
`;function e0({icon:o,title:r,subtitle:e,actions:t,spacing:n="md",hasIndentation:i=!1,variant:l="md",hasCentralize:p=!1}){return _react2.default.createElement(un,{variant:l,hasIndentation:i,spacing:n,hasCentralize:p},_react2.default.createElement(fe,null,o,_react2.default.createElement(x,{display:"grid",spacing:"sm"},_react2.default.createElement(fn,{variant:l},r),e&&_react2.default.createElement(xn,null,e))),_react2.default.createElement(fe,null,t))}var cl={lg:_styledcomponents.css`
    padding-block: 8px;
    padding-inline: ${({theme:o})=>o.space.lg};
  `,md:_styledcomponents.css`
    padding-block: 6px;
    padding-inline: ${({theme:o})=>o.space.md};
  `,sm:_styledcomponents.css`
    padding-block: 4px;
    padding-inline: ${({theme:o})=>o.space.sm};
  `,xsm:_styledcomponents.css`
    padding: ${({theme:o})=>o.space.xsm};
  `},ml={lg:_styledcomponents.css`
    padding-block: 0px;
    padding-inline: ${({theme:o})=>o.space.lg};
  `,md:_styledcomponents.css`
    padding-block: 0px;
    padding-inline: ${({theme:o})=>o.space.md};
  `,sm:_styledcomponents.css`
    padding-block: 0px;
    padding-inline: ${({theme:o})=>o.space.sm};
  `,xsm:_styledcomponents.css`
    padding-block: 0px;
    padding: ${({theme:o})=>o.space.xsm};
  `},gl={primary:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.primary.main+"30}"};
  `,secondary:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.secondary.main+"30}"};
  `,info:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.info.main+"30}"};
  `,warning:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.warning.main+"30}"};
  `,warningDark:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.warning.dark+"30}"};
  `,danger:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.danger.main+"30}"};
  `,dangerLight:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.danger.light};
  `,dangerDark:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.danger.dark+"50}"};
  `,white:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.white.main};
    border: 0.5px solid ${({theme:o})=>o.colors.neutral.main};
  `,black:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.black.main+"30}"};
  `,grey:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.grey[80]};
  `,overlay:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.black.main+"30}"};
  `,neutral:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.neutral.main+"30}"};
  `},bn=_styledcomponents2.default.div`
  ${({theme:o,color:r,fontColor:e,padding:t,isBordered:n,hasPaddingBlock:i,onClick:l})=>_styledcomponents.css`
    display: inline-flex;
    align-items: center;
    color: ${o.font.color[e]};
    border-radius: ${o.border.radius.xlg};
    padding: ${o.space.xsm} ${o.space.sm};
    font-size: ${o.font.size.sm};
    font-weight: ${o.font.weight.md};
    text-align: center;
    white-space: nowrap;

    ${n&&_styledcomponents.css`
      border: 1px solid ${o.colors.black.main}10;
    `}

    ${gl[r]}
    ${i?cl[t]:ml[t]}

    ${l&&_styledcomponents.css`
      cursor: pointer;
    `}
  `}
`,hn=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    width: ${o.space.md};
    height: ${o.space.md};
    padding-right: ${o.space.xsm};

    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 100%;
      height: 100%;
    }
  `}
`,yn=_styledcomponents2.default.button`
  ${({theme:o})=>_styledcomponents.css`
    padding-left: ${o.space.xsm};
    background: none;
    outline: none;
    border: none;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: ${o.space.md};
    }
  `}
`;function $n(s){var a=s,{icon:o,label:r,onDelete:e=void 0,color:t="primary",fontColor:n="main",padding:i="sm",hasPaddingBlock:l=!0,isBordered:p=!0}=a,d=b(a,["icon","label","onDelete","color","fontColor","padding","hasPaddingBlock","isBordered"]);return _react2.default.createElement(bn,u({color:t,fontColor:n,padding:i,hasPaddingBlock:l,isBordered:p},d),o&&_react2.default.createElement(hn,null,o),r,e&&_react2.default.createElement(yn,{onClick:e},_react2.default.createElement(_outline.XMarkIcon,null)))}var _solid3 = require('@heroicons/react/24/solid');var _reacttable = require('@tanstack/react-table');var _utils = require('@verde/utils');var Cn=_styledcomponents2.default.select`
  ${({theme:o})=>_styledcomponents.css`
    all: unset;

    appearance: auto;
    cursor: pointer;
    font-size: ${o.font.size.sm};
    color: ${o.colors.grey[200]};

    &:hover {
      filter: brightness(1.5);
    }
  `}
`,vn=_styledcomponents2.default.div`
  width: 1px;
  height: 16px;

  background-color: ${({theme:o})=>o.colors.grey[150]};
`,wn=_styledcomponents2.default.input`
  ${({theme:o})=>_styledcomponents.css`
    all: unset;

    width: 30px;
    height: 30px;

    text-align: center;
    color: ${o.colors.grey[200]};
    font-size: ${o.font.size.sm};
    border-radius: ${o.border.radius.sm};
    border: 1px solid ${o.colors.grey[150]};
    background-color: ${o.colors.white.main};

    &:hover {
      background-color: ${o.colors.grey[100]};
    }
  `}
`;function or({data:o=[],columns:r=[],gridColumns:e,header:t,onRowClick:n,isLoading:i,options:l}){let p=_react.useRef.call(void 0, null),d=u({globalSearch:!0,filterColumns:[]},l),[s,a]=_react.useState.call(void 0, []),[m,c]=_react.useState.call(void 0, ""),[h,f]=_react2.default.useState([]),g=_reacttable.useReactTable.call(void 0, {data:o,columns:r,state:{globalFilter:m,columnFilters:h,sorting:s},initialState:{pagination:{pageSize:or.PAGE_SIZE}},globalFilterFn:(S,C,xo)=>(()=>{var Q;if((Q=l==null?void 0:l.filterColumns)!=null&&Q.includes(C))return"";let T=S.getValue(C);return typeof T=="number"?String(T):_utils.normalizeString.call(void 0, String(T))})().includes(_utils.normalizeString.call(void 0, xo)),onSortingChange:a,onColumnFiltersChange:f,getCoreRowModel:_reacttable.getCoreRowModel.call(void 0, ),getSortedRowModel:_reacttable.getSortedRowModel.call(void 0, ),getFacetedRowModel:_reacttable.getFacetedRowModel.call(void 0, ),getFacetedUniqueValues:_reacttable.getFacetedUniqueValues.call(void 0, ),getFacetedMinMaxValues:_reacttable.getFacetedMinMaxValues.call(void 0, ),getFilteredRowModel:_reacttable.getFilteredRowModel.call(void 0, ),getPaginationRowModel:_reacttable.getPaginationRowModel.call(void 0, )}),y=_react.useMemo.call(void 0, ()=>g.getFilteredRowModel().flatRows.length,[g.getFilteredRowModel().flatRows.length]),$=_react.useMemo.call(void 0, ()=>g.getState().pagination.pageSize,[g.getState().pagination.pageSize]),D=_react.useMemo.call(void 0, ()=>s.length>0||m||h.length>0,[s,m,h]),E=_react.useCallback.call(void 0, ()=>{window.scroll({behavior:"smooth",top:p.current.offsetTop-or.SCROLL_TOP_OFFSET})},[]),B=_react.useCallback.call(void 0, S=>{if(E(),typeof S=="number"){g.setPageIndex(S);return}return{prev:g.previousPage,next:g.nextPage}[S]()},[]),Y=_react.useCallback.call(void 0, ()=>{a([]),c(""),f([])},[]);return _react2.default.createElement("div",{ref:p},_react2.default.createElement(Mn,null,_react2.default.createElement(Fn,null,d.globalSearch&&_react2.default.createElement(x,{width:"20%"},_react2.default.createElement(Ir,{placeholder:"Buscar...",value:m,onChange:S=>c(String(S.target.value))})),g.getHeaderGroups().map(S=>S.headers.map(C=>{var T;if(!C.column.getCanFilter()||!((T=d.filterColumns)!=null&&T.includes(C.id)))return null;let xo=Array.from(C.column.getFacetedUniqueValues().keys()).sort(),Ho=C.column.getFilterValue();return _react2.default.createElement(x,{width:"15%",key:C.id},_react2.default.createElement(In,{placeholder:C.isPlaceholder?null:_reacttable.flexRender.call(void 0, C.column.columnDef.header,C.getContext()),options:xo.map(Q=>({label:Q,value:Q})),value:Ho?{label:Ho,value:Ho}:null,onChange:Q=>{C.column.setFilterValue(Q==null?void 0:Q.value)}}))})),t&&t,D&&_react2.default.createElement(x,{ml:"auto"},_react2.default.createElement(j,{size:"sm",color:"primary",variant:"outlined",onClick:Y,icon:_react2.default.createElement(_solid3.XMarkIcon,null)},"Limpar filtros"))),_react2.default.createElement(Tn,{gridColumns:e},_react2.default.createElement(An,null,g.getHeaderGroups().map(S=>_react2.default.createElement($e,{key:S.id},S.headers.map(C=>_react2.default.createElement(Se,{key:C.id},_react2.default.createElement(Ln,{sortDirection:C.column.getIsSorted(),onClick:C.column.getToggleSortingHandler()},C.isPlaceholder?null:_reacttable.flexRender.call(void 0, C.column.columnDef.header,C.getContext()))))))),_react2.default.createElement(Bn,{isLoading:i},y<1&&_react2.default.createElement(Dn,null),g.getRowModel().rows.map(S=>_react2.default.createElement($e,{key:S.id,onClick:n==null?void 0:n.bind(null,S.original)},S.getVisibleCells().map(C=>_react2.default.createElement(Se,{key:C.id},_reacttable.flexRender.call(void 0, C.column.columnDef.cell,C.getContext())))))),_react2.default.createElement(zn,null,_react2.default.createElement(x,{alignItems:"center",spacing:"md"},_react2.default.createElement(Cn,{value:g.getState().pagination.pageSize,onChange:S=>{g.setPageSize(Number(S.target.value))}},[15,30,45,60].map(S=>_react2.default.createElement("option",{key:S,value:S},"Exibir ",S," itens"))),_react2.default.createElement(vn,null),_react2.default.createElement(v,{color:"light",size:"sm"},"Mostrando"," ",_utils.itensPageCounter.call(void 0, g.getState().pagination.pageIndex+1,y,$)," ","de ",y)),g.getPageCount()>1&&_react2.default.createElement(x,{display:"flex",alignItems:"center",spacing:"md"},_react2.default.createElement(q,{isDisabled:!g.getCanPreviousPage(),onClick:B.bind(null,"prev")},_react2.default.createElement(_solid3.ChevronLeftIcon,null)),_react2.default.createElement(x,{spacing:"sm",alignItems:"center"},_react2.default.createElement(v,{size:"sm",color:"light"},"P\xE1g."),_react2.default.createElement(wn,{type:"number",value:g.getState().pagination.pageIndex+1,onFocus:S=>S.target.select(),onChange:S=>{let C=parseInt(S.target.value);if(C>g.getPageCount()){B(g.getPageCount()-1);return}B(C-1)}}),_react2.default.createElement(v,{size:"sm",color:"light"},"de ",g.getPageCount())),_react2.default.createElement(q,{isDisabled:!g.getCanNextPage(),onClick:B.bind(null,"next")},_react2.default.createElement(_solid3.ChevronRightIcon,null)))))))}(t=>(t.columnHelper=_reacttable.createColumnHelper,t.PAGE_SIZE=15,t.SCROLL_TOP_OFFSET=20))(or||(or= exports.DataTable ={}));function z0(l){var p=l,{width:o,height:r,vertical:e,color:t="grey",thickness:n=1}=p,i=b(p,["width","height","vertical","color","thickness"]);let{colors:d}=_styledcomponents.useTheme.call(void 0, ),s=e?0:o||"initial",a=e?r||"auto":0,m=e?`${n}px`:"0",c=e?"0":`${n}px`;return _react2.default.createElement(x,u({as:"hr",width:s,height:a,borderRight:m,borderBottom:c,borderColor:d[t].main,borderBottomStyle:"solid",borderRightStyle:"solid"},i))}var Ll=o=>_styledcomponents.keyframes`
  from {
    ${o}: -100%;
  }
  to {
    ${o}: 0;
  }
`,Dl=o=>o==="left"||o==="right"?"vertical":"horizontal",To=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    position: relative;

    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    background-color: ${o.colors.white.main};
  `}
`,El={left:_styledcomponents.css`
    left: 0;
    top: 0;

    ${To} {
      ${({theme:o})=>_styledcomponents.css`
        border-radius: 0 ${o.border.radius.lg} ${o.border.radius.lg} 0;
      `}
    }
  `,right:_styledcomponents.css`
    right: 0;
    top: 0;

    ${To} {
      ${({theme:o})=>_styledcomponents.css`
        border-radius: ${o.border.radius.lg} 0 0 ${o.border.radius.lg};
      `}
    }
  `,top:_styledcomponents.css`
    top: 0;
    left: 0;

    ${To} {
      ${({theme:o})=>_styledcomponents.css`
        border-radius: 0 0 ${o.border.radius.lg} ${o.border.radius.lg};
      `}
    }
  `,bottom:_styledcomponents.css`
    bottom: 0;
    left: 0;

    ${To} {
      ${({theme:o})=>_styledcomponents.css`
        border-radius: ${o.border.radius.lg} ${o.border.radius.lg} 0 0;
      `}
    }
  `},Hl={vertical:{sm:_styledcomponents.css`
      width: 380px;
      height: 100vh;
    `,md:_styledcomponents.css`
      width: 500px;
      height: 100vh;
    `,lg:_styledcomponents.css`
      width: 600px;
      height: 100vh;
    `},horizontal:{sm:_styledcomponents.css`
      width: 100vw;
      height: 380px;
    `,md:_styledcomponents.css`
      width: 100vw;
      height: 500px;
    `,lg:_styledcomponents.css`
      width: 100vw;
      height: 600px;
    `}},En=_styledcomponents2.default.div`
  ${({theme:o,placement:r,size:e})=>_styledcomponents.css`
    position: fixed;
    z-index: ${o.layers.dialog};

    animation: ${Ll(r)} 0.5s ease;
    ${Hl[Dl(r)][e]}
    ${El[r]}

    ${To} {
    }
  `}
`,Hn=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${o.space.lg};
    padding-bottom: ${o.space.md};
    gap: ${o.space.sm};

    font-weight: bold;
    font-size: ${o.font.size.lg};
  `};
`,Nn=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    height: 100%;
    overflow-y: auto;
    padding-inline: ${o.space.lg};
    padding-bottom: ${o.space.lg};
  `}
`,_n=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    width: 100%;
    margin-top: auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: ${o.space.sm};
    padding: ${o.space.md} ${o.space.lg};
    border-top: 1px solid ${o.colors.grey[100]};
  `}
`;function O0(i){var l=i,{children:o,isOpen:r,placement:e="right",size:t="sm"}=l,n=b(l,["children","isOpen","placement","size"]);return xr(r),typeof r!="undefined"&&!r?null:_react2.default.createElement(En,u({placement:e,size:t},n),o)}var G0=_react.forwardRef.call(void 0, ({children:o},r)=>_react2.default.createElement(Nn,{ref:r},o));function X0({children:o}){return _react2.default.createElement(To,null,o)}function Q0({children:o}){return _react2.default.createElement(_n,null,o)}function R0({children:o}){return _react2.default.createElement(Hn,null,o)}var _reactdropzone = require('react-dropzone');var Gl=()=>({sm:_styledcomponents.css`
    ${({theme:o})=>_styledcomponents.css`
      p {
        font-size: ${o.font.size.sm};
      }

      svg {
        ${_polished.size.call(void 0, "32px")}
      }
    `}
  `,md:_styledcomponents.css`
    ${({theme:o})=>_styledcomponents.css`
      p {
        font-size: ${o.font.size.md};
      }

      svg {
        ${_polished.size.call(void 0, "56px")}
      }
    `}
  `}),Wn={hasError:_styledcomponents.css`
    ${({theme:o})=>_styledcomponents.css`
      color: ${o.colors.danger.main};
      border-color: ${o.colors.danger.light};
      background-color: ${_polished.rgba.call(void 0, o.colors.danger.main,.05)};

      &:hover {
        background-color: ${_polished.rgba.call(void 0, o.colors.danger.main,.1)};
      }
    `}
  `,isDisabled:_styledcomponents.css`
    ${({theme:o})=>_styledcomponents.css`
      cursor: not-allowed;
      color: ${o.colors.grey[200]};
      border-color: ${o.colors.grey[150]};
      background-color: ${_polished.rgba.call(void 0, o.colors.grey.main,.05)};

      &:hover {
        background-color: ${_polished.rgba.call(void 0, o.colors.grey.main,.1)};
      }
    `}
  `},Vn=_styledcomponents2.default.div`
  ${({theme:o,size:r,isLoading:e,isDisabled:t,hasError:n})=>_styledcomponents.css`
    min-height: 150px;
    max-height: 250px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: ${o.space.md};
    padding-block: ${o.space.sm};

    text-align: center;
    color: ${o.colors.secondary.main};
    border-radius: ${o.border.radius.sm};
    border: 1px dashed ${o.colors.primary.main};
    background-color: ${_polished.rgba.call(void 0, o.colors.primary.main,.1)};

    cursor: ${e?"progress":"pointer"};

    &:hover {
      background-color: ${_polished.rgba.call(void 0, o.colors.primary.main,.15)};
    }

    ${Gl()[r]}
    ${n&&Wn.hasError}
    ${!e&&t&&Wn.isDisabled}
  `}
`,Zn=_styledcomponents2.default.div`
  width: 100%;

  display: grid;
  place-items: center;
  gap: ${({theme:o})=>o.space.sm};
`,Gn=_styledcomponents2.default.div`
  width: 90%;
`;var jn=30,Kl={"file-invalid-type":"Formato de arquivo n\xE3o suportado.","file-too-large":`Arquivo excedeu o limite de tamanho de ${jn}MB.`},xu= exports.Dropzone =_react.forwardRef.call(void 0, (m,a)=>{var c=m,{isLoading:o=!1,isDisabled:r=!1,label:e,hasError:t=!1,size:n="md",progress:i,maxFiles:l,placeholder:p,onDrop:d}=c,s=b(c,["isLoading","isDisabled","label","hasError","size","progress","maxFiles","placeholder","onDrop"]);let h=!(typeof l=="number"&&l<2),f=O(),[g,y]=_react.useState.call(void 0, []),$=_react.useMemo.call(void 0, ()=>g.length>0,[g]),D=_react.useCallback.call(void 0, (S,C,xo)=>{if(C!=null&&C.length){y(C);return}y([]),d==null||d(S,C,xo)},[]),{getRootProps:E,getInputProps:B,isDragActive:Y}=_reactdropzone.useDropzone.call(void 0, Z(u({},s),{disabled:o||r,multiple:h,useFsAccessApi:!1,onDrop:D,maxSize:jn*1024*1024}));return _react2.default.createElement(Vn,Z(u({},E()),{hasError:$||t||(f==null?void 0:f.isInvalid),size:n,isLoading:o,isDisabled:r}),_react2.default.createElement("input",u({ref:a},B())),_react2.default.createElement(_outline.CloudArrowUpIcon,null),_react2.default.createElement(Zn,null,o&&_react2.default.createElement(_react2.default.Fragment,null,typeof i=="number"&&_react2.default.createElement(Gn,null,_react2.default.createElement(qn,{value:i})),_react2.default.createElement("p",null,h?"Carregando arquivos...":"Carregando arquivo..."," ")),!o&&e&&_react2.default.createElement("p",null,_react2.default.createElement("b",null,e)," ",f!=null&&f.isRequired?"(obrigat\xF3rio)":(f==null?void 0:f.isOptional)&&"(opcional)"),!o&&(Y?_react2.default.createElement("p",null,h?"Solte os arquivos aqui":"Solte o arquivo aqui"):_react2.default.createElement("p",null,$&&_react2.default.createElement(_react2.default.Fragment,null,g.map(({errors:S})=>S.map((C,xo)=>_react2.default.createElement(v,{key:`dropzone-error-item-${xo}`,size:"sm",as:"span",color:"danger",style:{display:"block"}},Kl[C.code])))),!$&&(p||(h?"Clique ou arraste os arquivos para essa \xE1rea":"Clique ou arraste um arquivo para essa \xE1rea"))))))});var Un=_styledcomponents2.default.fieldset`
  ${({theme:o,fullWidth:r,variant:e,padding:t})=>_styledcomponents.css`
    border-radius: ${o.border.radius.md};
    border: 1px solid ${o.colors[e].main};
    padding: ${o.space[t]};

    ${!r&&_styledcomponents.css`
      width: fit-content;
    `}
  `}
`,Yn=_styledcomponents2.default.legend`
  ${({theme:o})=>_styledcomponents.css`
    font-size: ${o.font.size.sm};
    font-weight: ${o.font.weight.md};
  `}
`;function vu(i){var l=i,{children:o,label:r,variant:e="grey",padding:t="md"}=l,n=b(l,["children","label","variant","padding"]);return _react2.default.createElement(Un,u({variant:e,padding:t},n),r&&_react2.default.createElement(Yn,null,r),o)}var Jn=_styledcomponents2.default.div`
  ${({theme:o,spacing:r=!1})=>_styledcomponents.css`
    display: grid;
    gap: ${o.space.sm};

    ${r&&_styledcomponents.css`
      margin-block: ${o.space.md};
    `}
  `}
`,ke=_styledcomponents2.default.div`
  width: 20px;
  height: 20px;

  color: ${({theme:o})=>o.colors.secondary.main};
`,Kn=_styledcomponents2.default.div`
  flex: 1;
  word-break: break-all;
`,Rn=_styledcomponents2.default.div`
  img,
  iframe {
    max-width: 200px;
    max-height: 200px;

    object-fit: contain;
  }
`,op={sm:`
    ${ke} {
      width: 14px;
      height: 14px;
    }
  `,md:"",lg:""},oi=_styledcomponents2.default.call(void 0, X)`
  ${({size:o})=>_styledcomponents.css`
    ${op[o]}
  `}
`;function Pe({data:o,file:r,hideSize:e,icon:t,onRemove:n,isRemoving:i,size:l="md"}){if(!o)return null;let p=_react.useMemo.call(void 0, ()=>{let s={"application/pdf":{Icon:_react2.default.createElement(_outline.DocumentTextIcon,null),Display:r&&_react2.default.createElement("iframe",{src:URL.createObjectURL(r)})},"text/csv":{Icon:_react2.default.createElement(_outline.TableCellsIcon,null)},"application/zip":{Icon:_react2.default.createElement(_outline.FolderIcon,null)},default:{Icon:_react2.default.createElement(_outline.PhotoIcon,null),Display:r&&_react2.default.createElement("img",{src:URL.createObjectURL(r)})}};return s[o.type]||s.default},[o.type]),d=_react.useCallback.call(void 0, ()=>{let s=_react2.default.createElement(x,{display:"flex",alignItems:"center",justifyContent:"center"},_react2.default.createElement(ke,null,p.Icon));return l!=="sm"?_react2.default.createElement(X,{isBordered:!0,padding:"sm",isFullWidth:!1},s):s},[l,p.Icon]);return _react2.default.createElement(oi,{isBordered:!0,padding:l==="sm"?"xsm":"sm",size:l},_react2.default.createElement(x,{display:"flex",spacing:l==="sm"?"xsm":"sm",alignItems:"center",justifyContent:"space-between"},t||_react2.default.createElement(d,null),_react2.default.createElement(x,{display:"flex",spacing:"sm",alignItems:"center",justifyContent:"space-between",flex:"1"},_react2.default.createElement(Kn,null,_react2.default.createElement(v,{size:l},o.name),o.description&&_react2.default.createElement(v,{color:"light",size:"xsm"},o.description),!e&&(r==null?void 0:r.size)&&_react2.default.createElement(v,{color:"light",size:"xsm"},_utils.formatFileSize.call(void 0, r.size))),_react2.default.createElement(x,{display:"flex",spacing:"sm",alignItems:"center"},(o.url||(p==null?void 0:p.Display))&&_react2.default.createElement(ri,{content:o.url?"Abrir":_react2.default.createElement(Rn,null,p==null?void 0:p.Display)},_react2.default.createElement(q,{as:"a",href:o.url,target:"_blank",size:l},_react2.default.createElement(_outline.EyeIcon,null))),n&&_react2.default.createElement(q,{bgColor:"grey",isLoading:i,onClick:n.bind(null,o),size:l},_react2.default.createElement(_outline.XMarkIcon,null))))))}(r=>r.Wrapper=Jn)(Pe||(Pe= exports.FileCard ={}));var ei={MIN:"35vw",MAX:"70vw"},ti={MIN:"55vh",MAX:"75vh"},nr=_styledcomponents2.default.div`
  width: 0;
  height: 100%;
  display: none;
`,Vo={Container:_styledcomponents2.default.div`
    ${({theme:o})=>_styledcomponents.css`
      height: 100%;
      display: flex;
      align-items: flex-start;

      &:after {
        width: ${o.space.md};
        height: 100%;
        display: block;

        content: "";
        box-shadow: ${o.shadows.card};
      }
    `}
  `,Content:_styledcomponents2.default.div`
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    gap: 4px;
  `,Item:_styledcomponents2.default.button`
    ${({theme:o,color:r})=>_styledcomponents.css`
      all: unset;

      position: relative;

      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: ${o.space.xsm};
      padding-inline: ${o.space.md};

      cursor: pointer;
      background-color: ${r};
      border-radius: 8px 0 0 8px;
      transition: padding-inline 0.15s;
      box-shadow: -4px 0px 6px rgba(0, 0, 0, 0.1);

      small {
        display: none;
      }

      &:hover {
        small {
          display: block;
        }
      }
    `}
  `,Icon:_styledcomponents2.default.div`
    ${({theme:o,filled:r})=>_styledcomponents.css`
      svg {
        width: 16px;
        height: 16px;
        fill: ${r&&o.colors.danger.main};
      }
    `}
  `},Ie={isOpen:_styledcomponents.css`
    ${nr} {
      width: ${ei.MIN};

      display: block;
    }
  `,isExpanded:_styledcomponents.css`
    height: ${ti.MAX};

    ${nr} {
      width: ${ei.MAX};
    }
  `,backgroundColor:o=>_styledcomponents.css`
    ${nr} {
      background-color: ${o};
    }

    ${Vo.Container} {
      &:after {
        background-color: ${o};
      }
    }
  `},ni=_styledcomponents2.default.div`
  ${({theme:o,color:r=o.colors.warning.light,isOpen:e,isExpanded:t})=>_styledcomponents.css`
    position: fixed;
    bottom: 0;
    right: 0;

    height: ${ti.MIN};

    ${e&&Ie.isOpen}
    ${t&&Ie.isExpanded}
    ${r&&Ie.backgroundColor(r)}
  `}
`,ii=_styledcomponents2.default.div`
  height: 100%;
  display: flex;
  align-items: flex-start;
`,Te={Container:_styledcomponents2.default.div`
    ${({theme:o})=>_styledcomponents.css`
      margin-top: ${o.space.md};
      margin-right: ${o.space.md};
      display: flex;
      align-items: center;
      justify-content: space-between;
    `}
  `,Icon:_styledcomponents2.default.div`
    ${({filled:o,theme:r})=>_styledcomponents.css`
      svg {
        width: 24px;
        height: 24px;
        fill: ${o&&r.colors.danger.main};
      }
    `}
  `},ai=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    height: 100%;
    overflow-y: auto;
    padding-bottom: 20vh;

    margin-block: ${o.space.md};
    padding-right: ${o.space.md};

    &::-webkit-scrollbar {
      width: 0;
    }
  `}
`;function hp({items:o,defaultOpen:r}){let[e,t]=_react.useState.call(void 0, !1),[n,i]=_react.useState.call(void 0, void 0),[l,p]=_react.useState.call(void 0, !1),d=_react.useCallback.call(void 0, m=>{i(c=>{if(c===m){t(!1);return}return t(!0),m})},[]),s=_react.useCallback.call(void 0, ()=>{p(m=>!m)},[]),a=_react.useMemo.call(void 0, ()=>o.find(m=>m.key===n),[n,o]);return _react.useEffect.call(void 0, ()=>{var m;r&&d((m=o.find(c=>c.key===r))==null?void 0:m.key)},[r]),o.length<1?null:_react2.default.createElement(_reactportal.Portal,null,_react2.default.createElement(ni,{isOpen:e,isExpanded:l,color:(a==null?void 0:a.color)||o[0].color||J.colors.warning.light},_react2.default.createElement(ii,null,_react2.default.createElement(Vo.Container,null,_react2.default.createElement(Vo.Content,null,o.map((f,h)=>{var g=f,{showBadge:m=!0}=g,c=b(g,["showBadge"]);let y=e&&(a==null?void 0:a.key)===c.key;return _react2.default.createElement(Vo.Item,{key:`floating-item-${h}`,color:c.color||J.colors.warning.light,onClick:d.bind(null,c.key)},c.isLoading&&_react2.default.createElement(so,{size:"sm"}),!c.isLoading&&_react2.default.createElement(_react2.default.Fragment,null,_react2.default.createElement(Vo.Icon,{filled:!!(c!=null&&c.count)&&m},y?_react2.default.createElement(_outline.ChevronRightIcon,null):c.icon),!!(c!=null&&c.count)&&!y&&_react2.default.createElement(v,{size:"sm",as:"small",color:"light"},"(",c.count,")")))}))),_react2.default.createElement(nr,null,_react2.default.createElement(Te.Container,null,_react2.default.createElement(x,{display:"flex",alignItems:"center",spacing:"xsm"},_react2.default.createElement(x,{display:"flex",alignItems:"center",spacing:"sm"},_react2.default.createElement(Te.Icon,{filled:!!(a!=null&&a.count)},a==null?void 0:a.icon),_react2.default.createElement(v,{size:"lg",weight:"bold"},a==null?void 0:a.title)),!!(a!=null&&a.count)&&_react2.default.createElement(v,{size:"sm",as:"small",color:"light"},"(",a==null?void 0:a.count,")")),_react2.default.createElement(x,{display:"flex",alignItems:"center",spacing:"md"},_react2.default.createElement(q,{bgColor:"grey",onClick:s},l?_react2.default.createElement(_outline.ArrowsPointingInIcon,null):_react2.default.createElement(_outline.ArrowsPointingOutIcon,null)),(a==null?void 0:a.action)&&_react2.default.createElement(j,{size:"sm",color:"secondary",variant:"outlined",onClick:a.action.onClick},a.action.children))),_react2.default.createElement(ai,null,a==null?void 0:a.children)))))}var yp=_react2.default.memo(hp);var li=_styledcomponents2.default.div`
  position: relative;

  width: 100%;
`;var di=_react.createContext.call(void 0, void 0);function O(){return _react.useContext.call(void 0, di)}function Qu(e){var t=e,{children:o}=t,r=b(t,["children"]);return _react2.default.createElement(di.Provider,{value:r},_react2.default.createElement(li,null,o))}var _reactdatepicker = require('react-date-picker');var kp=o=>_styledcomponents.css`
  .react-date-picker {
    position: relative;

    display: flex;
    font-size: ${o.font.size.md};
    background-color: ${o.colors.white.main};
  }

  .react-date-picker__wrapper {
    height: 40px;
    flex-grow: 1;
    display: flex;
    align-items: center;
    padding-inline: ${o.space.sm};

    border-radius: ${o.border.radius.xsm};
    border: 1px solid ${o.colors.grey[150]};
  }

  .react-date-picker__inputGroup {
    flex-grow: 1;
    padding: 0 2px;
    box-sizing: content-box;
  }

  .react-date-picker__inputGroup__divider {
    padding: 1px 0;
    white-space: pre;
  }

  .react-date-picker__inputGroup__divider,
  .react-date-picker__inputGroup__leadingZero {
    display: inline-block;
  }

  .react-date-picker__inputGroup__input {
    all: unset;

    position: relative;

    appearance: textfield;
  }

  .react-date-picker__inputGroup__input::-webkit-outer-spin-button,
  .react-date-picker__inputGroup__input::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }

  .react-date-picker__inputGroup__input:invalid {
    background-color: ${o.colors.danger.light};
  }

  .react-date-picker__inputGroup__input--hasLeadingZero {
    margin-left: -0.54em;
    padding-left: calc(1px + 0.54em);
  }

  .react-date-picker__button {
    all: unset;

    width: 24px;
    height: 24px;
    display: grid;
    place-items: center;

    border-radius: ${o.border.radius.full};

    &:first-of-type {
      margin-left: auto;
    }

    &:not(:first-of-type) {
      margin-left: ${o.space.sm};
    }

    &:enabled {
      cursor: pointer;

      &:hover {
        background-color: ${o.colors.grey.main};
      }
    }
  }

  .react-date-picker__button svg {
    width: 16px;
    height: 16px;
  }

  .react-date-picker__calendar {
    z-index: 1;

    width: 300px;
    max-width: 100vw;
    margin-top: ${o.space.sm};
  }

  .react-date-picker__calendar--closed {
    display: none;
  }
`,Pp=o=>_styledcomponents.css`
  .react-calendar {
    max-width: 100%;

    background-color: ${o.colors.white.main};
    border-radius: ${o.border.radius.xsm};
    border: 1px solid ${o.colors.grey[150]};
  }

  .react-calendar button {
    outline: none;
    border: none;

    display: grid;
    place-items: center;
    font-size: ${o.font.size.sm};

    &:enabled {
      cursor: pointer;

      &:hover {
        color: ${o.font.color.main};
        background-color: ${o.colors.grey.main};
      }
    }
  }

  .react-calendar__navigation {
    display: flex;
    height: 48px;

    background-color: ${o.colors.grey[50]};
  }

  .react-calendar__navigation button {
    min-width: 44px;
    background: none;
  }

  .react-calendar__navigation button:disabled {
    background-color: ${o.colors.grey[80]};
  }

  .react-calendar__navigation button:enabled:hover,
  .react-calendar__navigation button:enabled:focus {
    background-color: ${o.colors.grey[150]};
  }

  .react-calendar__viewContainer {
    padding: ${o.space.sm};
  }

  .react-calendar__month-view__weekdays {
    text-align: center;
    text-transform: uppercase;
    font-weight: bold;
    font-size: ${o.font.size.xsm};
    color: ${o.font.color.main};

    abbr {
      text-decoration: none;
    }
  }

  .react-calendar__month-view__weekdays__weekday {
    padding: 0.5em;
  }

  .react-calendar__month-view__weekNumbers .react-calendar__tile {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75em;
  }

  .react-calendar__month-view__days__day--weekend,
  .react-calendar__month-view__days__day--neighboringMonth {
    color: ${o.font.color.lighter};
  }

  .react-calendar__year-view .react-calendar__tile,
  .react-calendar__decade-view .react-calendar__tile,
  .react-calendar__century-view .react-calendar__tile {
    padding: 2em 0.5em;
  }

  .react-calendar__tile {
    max-width: 100%;
    padding-block: 10px;

    text-align: center;
    line-height: 16px;

    background: none;
    border-radius: ${o.border.radius.xsm};
  }

  .react-calendar__tile:disabled {
    background-color: ${o.colors.grey[80]};
  }

  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus {
    background-color: #e6e6e6;
  }

  .react-calendar__tile--now {
    color: ${o.colors.primary.dark};
    background-color: ${o.colors.primary.light};

    &:hover {
      background-color: ${o.colors.primary.main} !important;
    }
  }

  .react-calendar__tile--hasActive {
    background-color: ${o.colors.secondary.main};
  }

  .react-calendar__tile--active {
    color: ${o.colors.primary.main};
    background-color: ${o.colors.secondary.main};

    &:hover {
      color: ${o.colors.primary.dark} !important;
      background-color: ${o.colors.secondary.main} !important;
    }
  }
`,Be={disabled:_styledcomponents.css`
    opacity: 0.6;
  `,readOnly:_styledcomponents.css`
    .react-date-picker__wrapper {
      background-color: ${({theme:o})=>o.colors.grey[80]};
    }
  `,isInvalid:_styledcomponents.css`
    .react-date-picker__wrapper {
      color: ${({theme:o})=>o.colors.danger.main};
      border-color: ${({theme:o})=>o.colors.danger.light};
    }
  `},ci=_styledcomponents2.default.div`
  ${({theme:o,disabled:r,isInvalid:e,readOnly:t})=>_styledcomponents.css`
    ${kp(o)}
    ${Pp(o)}

    ${e&&Be.isInvalid}
    ${r&&Be.disabled}
    ${t&&Be.readOnly}
  `}
`;var d2=_react.forwardRef.call(void 0, (d,p)=>{var s=d,{value:o,onChange:r,disabled:e,isInvalid:t,readOnly:n,isClearable:i=!0}=s,l=b(s,["value","onChange","disabled","isInvalid","readOnly","isClearable"]);let a=O(),m=(a==null?void 0:a.disabled)||e,c=(a==null?void 0:a.readOnly)||n,h=_react.useCallback.call(void 0, y=>{var E;let $=y;$.stopPropagation(),$.preventDefault();let D=(E=$.clipboardData)==null?void 0:E.getData("text").split("/").reverse().join("-");_utils.dayjs.call(void 0, D).isValid()&&(r==null||r(D))},[r]),f=_react.useCallback.call(void 0, ()=>{addEventListener("paste",h)},[l.onFocus,h]),g=_react.useCallback.call(void 0, ()=>{removeEventListener("paste",h)},[l.onFocus,h]);return _react2.default.createElement(ci,{disabled:m,readOnly:c,isInvalid:(a==null?void 0:a.isInvalid)||t},_react2.default.createElement(_reactdatepicker.DatePicker,Z(u({inputRef:p},l),{value:o?_utils.dayjs.call(void 0, o).toDate():void 0,format:"dd/MM/yy",calendarIcon:_react2.default.createElement(_outline.CalendarIcon,null),clearIcon:i&&(o?_react2.default.createElement(_outline.XMarkIcon,null):null),locale:"pt-BR",onChange:r,disabled:m||c,onCalendarOpen:f,onCalendarClose:g})))});var Fp={default:_styledcomponents.css`
    color: ${({theme:o})=>o.font.color.lighter};
  `,error:_styledcomponents.css`
    color: ${({theme:o})=>o.colors.danger.main};
  `},gi=_styledcomponents2.default.div`
  ${({theme:o,kind:r})=>_styledcomponents.css`
    margin-top: ${o.space.xsm};

    font-size: ${o.font.size.sm};

    ${Fp[r]}

    > * {
      text-align: right;
    }
  `}
`;function y2({children:o}){let r=O();return o?_react2.default.createElement(gi,{kind:r!=null&&r.isInvalid?"error":"default"},o):null}var Fe={disabled:_styledcomponents.css`
    opacity: 0.6;
  `,readOnly:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.grey[80]};
  `,isInvalid:_styledcomponents.css`
    color: ${({theme:o})=>o.colors.danger.main};
    border-color: ${({theme:o})=>o.colors.danger.light};
  `},Ep={white:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.white.main};
  `,grey:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.grey[50]};
  `},Hp={solid:_styledcomponents.css`
    border-style: solid;
  `,dashed:_styledcomponents.css`
    border-style: dashed;
  `},fi=_styledcomponents2.default.label`
  ${({theme:o,disabled:r,isInvalid:e,readOnly:t,color:n,variant:i})=>_styledcomponents.css`
    position: relative;

    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    color: ${o.font.color.main};
    border-radius: ${o.border.radius.xsm};
    border-width: 1px;
    border-color: ${o.colors.grey[150]};

    cursor: text;

    > input {
      all: unset;

      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-inline: ${o.space.sm};
      font-size: ${o.font.size.md};

      &::-webkit-inner-spin-button,
      &::-webkit-calendar-picker-indicator {
        position: absolute;
        top: 50%;
        right: ${o.space.sm};
        transform: translateY(-50%);
      }
    }

    ${e&&Fe.isInvalid}
    ${i&&Hp[i]}
    ${Ep[n]}
    ${r&&Fe.disabled}
    ${t&&Fe.readOnly}
  `}
`,ui=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    padding-right: ${o.space.sm};
    white-space: nowrap;

    > svg {
      width: 14px;
      height: 14px;

      color: ${o.font.color.main};
    }
  `}
`,xi=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    padding-left: ${o.space.md};
    white-space: nowrap;
  `}
`;var Ir=_react.forwardRef.call(void 0, (a,s)=>{var m=a,{isInvalid:o,disabled:r,readOnly:e,color:t="white",variant:n="solid",leftAdornment:i,rightAdornment:l,type:p}=m,d=b(m,["isInvalid","disabled","readOnly","color","variant","leftAdornment","rightAdornment","type"]);let c=O(),[h,f]=_react.useState.call(void 0, ()=>p),g=(c==null?void 0:c.disabled)||r,y=(c==null?void 0:c.readOnly)||e,$=l||p&&["password"].includes(p),D=!!i,E=_react.useCallback.call(void 0, ()=>{f(B=>B==="password"?"text":"password")},[]);return _react2.default.createElement(fi,{color:t,variant:n,disabled:g,readOnly:y,isInvalid:(c==null?void 0:c.isInvalid)||o},D&&_react2.default.createElement(xi,null,i),_react2.default.createElement("input",u({disabled:g,readOnly:y,ref:s,type:h},d)),$&&_react2.default.createElement(ui,null,p==="password"?_react2.default.createElement(q,{size:"sm",type:"button",onClick:E},h==="password"?_react2.default.createElement(_outline.EyeIcon,null):_react2.default.createElement(_outline.EyeSlashIcon,null)):l))});var _reactimask = require('react-imask');var _2=_react.forwardRef.call(void 0, (l,i)=>{var p=l,{value:o,options:d}=p,s=d,{unmask:r=!1}=s,e=b(s,["unmask"]),a=p,{onChange:t}=a,n=b(a,["value","options","onChange"]);let[m]=_react.useState.call(void 0, ()=>e),c=_reactimask.useIMask.call(void 0, m,{onAccept(f,g,y){if(!y)return;let $=r?g.unmaskedValue:f,D=m.mask===Number?_utils.formatToFloat.call(void 0, $):$;t==null||t(D)}});function h(f){i&&(typeof i=="function"?i(f):i.current=f),f&&(c.ref.current=f)}return _react.useEffect.call(void 0, ()=>{typeof o!="undefined"&&o!=null&&(typeof o=="number"?(c.setTypedValue(o),c.maskRef.current.typedValue=o):(c.setValue(o),c.maskRef.current.value=o))},[o]),_react2.default.createElement(Ir,Z(u({},n),{ref:h}))}),O2= exports.InputMaskHelpers =_reactimask.IMask,W2= exports.InputMaskOptions ={Number:{mask:Number,scale:2,thousandsSeparator:".",radix:",",padFractionalZeros:!0,normalizeZeros:!0,overwrite:!0},CPF:{mask:"000.000.000-00",unmask:!0},CNPJ:{mask:"00.000.000/0000-00",unmask:!0},Document:{mask:[{mask:"000.000.000-00"},{mask:"00.000.000/0000-00"}],unmask:!0},Homephone:{mask:"(00) 0000-0000",unmask:!0},Cellphone:{mask:"(00) 0 0000-0000",unmask:!0},Phone:{mask:[{mask:"(00) 0000-0000"},{mask:"(00) 0 0000-0000"}],unmask:!0},Zipcode:{mask:"00000-000",unmask:!0}};var yi=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    margin-bottom: ${o.space.xsm};

    color: ${o.font.color.main};
    font-size: ${o.font.size.sm};
    font-weight: ${o.font.weight.md};
  `}
`,De=_styledcomponents2.default.span`
  ${({theme:o})=>_styledcomponents.css`
    font-weight: ${o.font.weight.xsm};
    color: ${o.font.color.lighter};
  `}
`;function Q2({children:o}){let r=O();return _react2.default.createElement(yi,null,o," ",r!=null&&r.isRequired?_react2.default.createElement(De,null,"(obrigat\xF3rio)"):(r==null?void 0:r.isOptional)&&_react2.default.createElement(De,null,"(opcional)"))}var He=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    width: 12px;
    height: 12px;

    border-radius: ${o.border.radius.full};
    background-color: ${o.colors.grey[200]};
  `}
`,$o=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    display: grid;
    place-items: center;

    color: ${o.font.color.lighter};
    background-color: ${o.colors.grey[50]};

    > svg {
      width: 10px;
      height: 10px;
    }
  `}
`,Mr=_styledcomponents2.default.input`
  display: none;

  ${({theme:o})=>_styledcomponents.css`
    &:checked + ${$o} {
      color: black;
      border-color: ${o.colors.secondary.main};
      background-color: ${o.colors.secondary.main};

      > svg {
        display: inline;

        > circle {
          fill: ${o.colors.white.main};
        }
      }

      ${He} {
        margin-left: auto;

        background-color: ${o.colors.white.main};
      }
    }
  `}
`,Ne=_styledcomponents2.default.span`
  ${({theme:o})=>_styledcomponents.css`
    line-height: 1;
    font-size: ${o.font.size.sm};
    color: ${o.font.color.main};
    font-weight: ${o.font.weight.md};
  `}
`,Kp=()=>({checkbox:_styledcomponents.css`
    ${({theme:o})=>_styledcomponents.css`
      display: grid;
      place-items: center;
      width: ${o.font.size.lg};
      height: ${o.font.size.lg};
      background-color: ${o.colors.white.main};
      border: 2px solid ${o.colors.grey[150]};
      border-radius: ${o.border.radius.xsm};

      svg {
        display: none;
        color: ${o.colors.white.main};
      }
    `}
  `,radio:_styledcomponents.css`
    ${({theme:o})=>_styledcomponents.css`
      display: grid;
      place-items: center;
      width: 16px;
      height: 16px;
      border-radius: ${o.border.radius.full};
      border: 1px solid ${o.colors.grey[100]};
    `}
  `,switch:_styledcomponents.css`
    ${({theme:o})=>_styledcomponents.css`
      display: flex;
      align-items: center;
      padding-inline: 2px;
      width: 32px;
      height: 18px;
      border-radius: ${o.border.radius.lg};
      border: 1px solid ${o.colors.grey[200]};
    `}
  `}),ir={isInvalid:_styledcomponents.css`
    ${({theme:o})=>_styledcomponents.css`
      ${$o} {
        color: ${o.colors.danger.main};
        background-color: ${o.colors.danger.light};
      }

      ${Ne} {
        color: ${o.colors.danger.main};
      }

      ${Mr} {
        &:checked + ${$o} {
          background-color: ${o.colors.danger.main};
        }
      }
    `}
  `,disabled:_styledcomponents.css`
    ${({theme:o})=>_styledcomponents.css`
      opacity: 0.7;
      cursor: not-allowed;

      ${$o} {
        border-color: ${o.colors.grey[150]};
        background-color: ${o.colors.grey[150]};
      }

      ${Mr} {
        &:checked + ${$o} {
          border-color: ${o.colors.grey[150]};
          background-color: ${o.colors.grey[150]};

          svg {
            color: ${o.colors.grey[200]};
          }
        }
      }
    `}
  `,readOnly:_styledcomponents.css`
    pointer-events: none;
  `,outlined:_styledcomponents.css`
    ${({theme:o})=>_styledcomponents.css`
      height: 36px;
      padding-inline: ${o.space.sm};
      border-radius: ${o.border.radius.sm};
      border: 1px solid ${o.colors.grey[150]};
      background-color: ${o.colors.grey[50]};
    `}
  `,isFullWidth:_styledcomponents.css`
    width: 100%;
  `},$i=_styledcomponents2.default.label`
  ${({theme:o,kind:r,isInvalid:e,readOnly:t,disabled:n,outlined:i,isFullWidth:l})=>_styledcomponents.css`
    display: inline-flex;
    align-items: center;
    gap: ${o.space.sm};

    user-select: none;
    cursor: pointer;

    ${$o} {
      ${Kp()[r]}
    }

    ${l&&ir.isFullWidth}
    ${i&&ir.outlined}
    ${e&&ir.isInvalid}
    ${n&&ir.disabled}
    ${t&&ir.readOnly}
  `}
`;var ix=_react.forwardRef.call(void 0, (p,l)=>{var d=p,{kind:o="checkbox",outlined:r=!0,label:e,isInvalid:t,isFullWidth:n}=d,i=b(d,["kind","outlined","label","isInvalid","isFullWidth"]);let s=O(),a=o==="radio"?"radio":"checkbox",m=(s==null?void 0:s.disabled)||i.disabled,c=(s==null?void 0:s.readOnly)||i.readOnly;return _react2.default.createElement($i,{outlined:r,disabled:m,readOnly:c,isInvalid:(s==null?void 0:s.isInvalid)||t,isFullWidth:n,kind:o},_react2.default.createElement(Mr,u({type:a,disabled:m,ref:l},i)),_react2.default.createElement($o,null,o==="switch"?_react2.default.createElement(He,null):_react2.default.createElement(_react2.default.Fragment,null,o==="radio"?_react2.default.createElement("svg",{fill:"nome",viewBox:"0 0 24 24"},_react2.default.createElement("circle",{cx:"12",cy:"12",r:"11","stroke-width":"3",fill:"none"})):_react2.default.createElement("svg",{fill:"none",viewBox:"0 0 12 9"},_react2.default.createElement("path",{stroke:"white",strokeLinecap:"round",strokeLinejoin:"round",strokeWidth:2.5,d:"m2 3.502 3.5 3.5 5-5.5"})))),e&&_react2.default.createElement(Ne,null,e))});var _reactselect = require('react-select'); var _reactselect2 = _interopRequireDefault(_reactselect);var rd={sm:_styledcomponents.css`
    height: 32px;
    min-height: 32px;
  `,md:_styledcomponents.css`
    height: 40px;
    min-height: 40px;
  `},_e={disabled:_styledcomponents.css`
    opacity: 0.6;
  `,readOnly:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.grey[80]};
  `,isInvalid:_styledcomponents.css`
    color: ${({theme:o})=>o.colors.danger.main};
    border-color: ${({theme:o})=>o.colors.danger.light};
  `},ed={white:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.white.main};
  `,grey:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.grey[50]};
  `},Si=_styledcomponents2.default.label`
  ${({theme:o,disabled:r,color:e,size:t,isInvalid:n,readOnly:i})=>_styledcomponents.css`
    position: relative;

    height: 38px;
    min-height: 38px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    color: ${o.font.color.main};
    border-radius: ${o.border.radius.xsm};
    border: 1px solid ${o.colors.grey[150]};
    font-size: ${o.font.size.md};

    &:focus-within {
      border: 1px solid ${o.colors.black.main};
    }

    ${ed[e]}
    ${rd[t]}
    ${r&&_e.disabled}
    ${n&&_e.isInvalid}
    ${i&&_e.readOnly}
  `}
`,Ci=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    width: 100%;
    height: 100%;

    > .select {
      width: 100%;
      height: 100%;

      .select__control {
        width: 100%;
        height: 100%;
        min-height: 100%;

        border: none;
        background-color: transparent;
      }

      .select__menu {
        box-shadow: none;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.05);
        border: 1px solid ${o.colors.grey[100]};
      }

      .select__option {
        cursor: pointer;

        svg {
          width: ${o.font.size.lg};
          height: ${o.font.size.lg};
        }
      }

      .select__value-container {
        gap: 2px;
      }

      .select__single-value--is-disabled {
        color: inherit;
      }

      .select__indicators {
        display: flex;
        gap: ${o.space.xsm};
        margin-right: ${o.space.sm};
      }
    }
  `}
`,zr=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    width: ${o.space.lg};
    height: ${o.space.lg};
    display: grid;
    place-items: center;

    cursor: pointer;
    border-radius: ${o.border.radius.full};

    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }

    > svg {
      width: ${o.font.size.md};
      height: ${o.font.size.md};
    }
  `}
`,cx=_styledcomponents2.default.div`
  display: inline-flex;
  gap: ${({theme:o})=>o.space.xsm};
`;var In=_react.forwardRef.call(void 0, ({name:o,options:r,value:e,defaultValue:t,onChange:n,isInvalid:i,disabled:l,readOnly:p,maxMenuHeight:d,isMulti:s=!1,isLoading:a=!1,isClearable:m=!0,menuPlacement:c="auto",placeholder:h="Selecione",color:f="white",size:g="md",mode:y="complete",emptyMessage:$="Nenhuma op\xE7\xE3o"},D)=>{let E=_styledcomponents.useTheme.call(void 0, ),B=O(),Y=(B==null?void 0:B.disabled)||l,S=(B==null?void 0:B.readOnly)||p,C=_react.useMemo.call(void 0, ()=>y==="simple"?(r==null?void 0:r.find(T=>T.value===e))||null:e,[y,e,r]),xo=_react.useCallback.call(void 0, (T,Q)=>{n==null||n(y==="simple"?(T==null?void 0:T.value)||void 0:T,Q)},[y]),Ho=T=>{let ft=T,{children:Q}=ft,Qa=b(ft,["children"]);return _react2.default.createElement(_reactselect.components.Option,u({},Qa),_react2.default.createElement(x,{display:"flex",alignItems:"center",spacing:"sm",style:{wordBreak:"break-all"}},!s&&T.data.icon,Q))};return _react2.default.createElement(Si,{size:g,color:f,readOnly:S,disabled:Y,isInvalid:(B==null?void 0:B.isInvalid)||i},_react2.default.createElement(Ci,null,_react2.default.createElement(_reactselect2.default,{ref:D,className:"select",name:o,options:r,isDisabled:Y||S,placeholder:h,noOptionsMessage:()=>$,menuShouldScrollIntoView:!1,maxMenuHeight:d,menuPlacement:c,isClearable:m,styles:{control:T=>Z(u({},T),{boxShadow:"none"})},components:{Option:Ho,DropdownIndicator:()=>_react2.default.createElement(zr,null,_react2.default.createElement(_solid3.ChevronDownIcon,null)),IndicatorSeparator:()=>null,MultiValueContainer:({children:T})=>_react2.default.createElement($n,{label:T}),LoadingIndicator:()=>_react2.default.createElement(zr,null,_react2.default.createElement(so,{color:"primary",size:"sm"})),ClearIndicator:({innerProps:T})=>_react2.default.createElement(zr,u({},T),_react2.default.createElement(_solid3.XMarkIcon,null))},theme:T=>Z(u({},T),{colors:Z(u({},T.colors),{primary:E.colors.primary.main,primary25:E.colors.primary.light,primary50:E.colors.primary.main,primary75:E.colors.primary.dark,danger:E.colors.danger.main})}),isMulti:s,classNamePrefix:"select",value:C,defaultValue:t,isLoading:a,loadingMessage:()=>"Carregando...",onChange:xo,menuPosition:"fixed"})))});var vi={disabled:_styledcomponents.css`
    opacity: 0.6;
  `,isInvalid:_styledcomponents.css`
    border-color: ${({theme:o})=>o.colors.danger.light};
  `},gd={white:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.white.main};
  `,grey:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.grey[50]};
  `},wi=_styledcomponents2.default.textarea`
  ${({theme:o,isInvalid:r,color:e,disabled:t})=>_styledcomponents.css`
    all: unset;

    width: 100%;
    min-height: 55px;
    padding: 12px ${o.space.sm};
    box-sizing: border-box;
    display: block;
    border-radius: ${o.border.radius.sm};
    border: 1px solid ${o.colors.grey[150]};
    font-size: ${o.font.size.md};

    word-break: break-all;
    resize: vertical;

    ${gd[e]}

    &::placeholder {
      color: ${o.font.color.light};
    }

    ::-webkit-scrollbar {
      width: 5px;
    }

    ::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.04);
    }

    ::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.1);
    }

    ::-webkit-scrollbar-thumb:hover {
      background: rgba(0, 0, 0, 0.15);
    }

    ${r&&vi.isInvalid}
    ${t&&vi.disabled}
  `}
`;var zx=_react.forwardRef.call(void 0, (t,e)=>{var n=t,{color:o="white"}=n,r=b(n,["color"]);let i=O();return _react2.default.createElement(wi,u({disabled:i==null?void 0:i.disabled,readOnly:i==null?void 0:i.readOnly,isInvalid:i==null?void 0:i.isInvalid,ref:e,color:o},r))});var ki=_styledcomponents2.default.header`
  ${({theme:o})=>_styledcomponents.css`
    position: static;
    z-index: ${o.layers.header};

    padding: ${o.space.md};

    background-color: ${o.colors.grey[50]};
  `}
`,Pi=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    position: relative;

    display: flex;
    align-items: center;
    gap: ${o.space.md};
  `}
`,Ii=_styledcomponents2.default.div`
  ${Cr} {
    ${_styledmediaquery2.default.lessThan("medium")`
      &:not(:last-of-type) {
        display: none;
      }
    `}
  }
`,Ti=_styledcomponents2.default.div`
  margin-left: auto;
`,Mi=_styledcomponents2.default.div`
  position: absolute;
  top: 64px;
  left: 16px;

  height: 100%;

  ${_styledmediaquery2.default.lessThan("large")`
    position: fixed;
    top: 0;

    width: 100%;
  `}
`,Bi=_styledcomponents2.default.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  background-color: ${({theme:o})=>o.colors.overlay.main};

  ${_styledmediaquery2.default.greaterThan("large")`
    display: none;
  `}
`,zi=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    position: relative;

    display: flex;
    align-items: center;
    gap: ${o.space.md};
  `}
`;function r3({breadcrumb:o,logo:r,navigationMenu:e,footerLinks:t,footerRender:n,actions:i}){let l=_react.useRef.call(void 0, null),[p,d]=_react.useState.call(void 0, !1);function s(){d(m=>!m)}let a=_react.useCallback.call(void 0, ()=>{d(!1)},[]);return yt(l,d.bind(null,!1)),_react2.default.createElement(ki,{ref:l},_react2.default.createElement(Pi,null,e&&_react2.default.createElement(j,{icon:_react2.default.createElement(_solid3.Bars3Icon,null),variant:"outlined",color:"white",onClick:s}),_react2.default.createElement(Ii,null,_react2.default.createElement(pn,{items:o})),_react2.default.createElement(Ti,null,_react2.default.createElement(zi,null,i))),e&&p&&_react2.default.createElement(Mi,null,_react2.default.createElement(Ai,{logo:r,menu:e,footerLinks:t,onFiredAction:a,footerRender:n}),_react2.default.createElement(Bi,{onClick:d.bind(null,!1)})))}var Ve={};Ra(Ve,{rightarrow:()=>vd,rightdivider:()=>Cd});function Cd(i){var l=i,{color:o,hasGradient:r,width:e,height:t}=l,n=b(l,["color","hasGradient","width","height"]);return _react2.default.createElement("svg",{viewBox:"0 0 6 70",fill:"none",xmlns:"http://www.w3.org/2000/svg",width:e,height:t},_react2.default.createElement("defs",null,_react2.default.createElement("linearGradient",{id:"gradient",x1:"1",y1:"1",x2:"35",y2:"37",gradientUnits:"userSpaceOnUse"},_react2.default.createElement("stop",{"stop-color":"white",offset:"0%"}),_react2.default.createElement("stop",{"stop-color":J.colors[o].main,offset:"55%"}),_react2.default.createElement("stop",{"stop-color":"white",offset:"100%"}))),_react2.default.createElement("path",u({d:"M1.09728 1.48738e-07L1.09724 32.0833L4.5 35L1.09724 37.4306L1.09728 70",stroke:r?"url(#gradient)":J.colors[o].main},n)))}function vd(n){var i=n,{color:o,width:r,height:e}=i,t=b(i,["color","width","height"]);return _react2.default.createElement("svg",{viewBox:"0 0 306 4",fill:"none",xmlns:"http://www.w3.org/2000/svg",width:r,height:e},_react2.default.createElement("path",u({d:"M0.666667 2C0.666667 2.73638 1.26362 3.33333 2 3.33333C2.73638 3.33333 3.33333 2.73638 3.33333 2C3.33333 1.26362 2.73638 0.666667 2 0.666667C1.26362 0.666667 0.666667 1.26362 0.666667 2ZM305.177 2.17678C305.274 2.07915 305.274 1.92085 305.177 1.82322L303.586 0.232233C303.488 0.134602 303.33 0.134602 303.232 0.232233C303.135 0.329864 303.135 0.488155 303.232 0.585786L304.646 2L303.232 3.41421C303.135 3.51184 303.135 3.67014 303.232 3.76777C303.33 3.8654 303.488 3.8654 303.586 3.76777L305.177 2.17678ZM2 2.25H305V1.75H2V2.25Z",fill:J.colors[o].main,stroke:J.colors[o].main},t)))}var h3=n=>{var i=n,{icon:o,color:r="grey",hasGradient:e=!1}=i,t=b(i,["icon","color","hasGradient"]);let l=Ve[o];return l?_react2.default.createElement(l,u({color:r,hasGradient:e},t)):_react2.default.createElement(_outline.XMarkIcon,{width:18})};var Pd={white:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.white.main};
  `,grey:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.grey.main};
  `,warning:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.warning.light};
  `,primary:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.primary.main};
  `,purple:_styledcomponents.css`
    background-color: ${({theme:o})=>o.colors.purple.main};
  `},Id={xsm:_styledcomponents.css`
    ${_polished.size.call(void 0, "14px")}

    > svg {
      ${_polished.size.call(void 0, "10px")}
    }
  `,sm:_styledcomponents.css`
    ${_polished.size.call(void 0, "24px")}

    > svg {
      ${_polished.size.call(void 0, "14px")}
    }
  `,md:_styledcomponents.css`
    ${_polished.size.call(void 0, "32px")}

    > svg {
      ${_polished.size.call(void 0, "18px")}
    }
  `,lg:_styledcomponents.css`
    ${_polished.size.call(void 0, "40px")}

    > svg {
      ${_polished.size.call(void 0, "22px")}
    }
  `,xlg:_styledcomponents.css`
    ${_polished.size.call(void 0, "48px")}

    > svg {
      ${_polished.size.call(void 0, "26px")}
    }
  `,"2xl":_styledcomponents.css`
    ${_polished.size.call(void 0, "64px")}

    > svg {
      ${_polished.size.call(void 0, "32px")}
    }
  `},Td={sm:_styledcomponents.css`
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  `},Md={isDisabled:_styledcomponents.css`
    ${({theme:o})=>_styledcomponents.css`
      cursor: not-allowed;
      color: ${o.font.color.lighter};
      background-color: ${o.colors.grey[150]};
    `}
  `},Di=_styledcomponents2.default.button`
  ${({theme:o,bgColor:r,color:e,size:t,disabled:n,shadow:i})=>_styledcomponents.css`
    all: unset;

    display: grid;
    place-items: center;

    cursor: pointer;
    transition: 0.15s;
    box-sizing: border-box;
    color: ${e==="grey"?o.font.color.main:o.colors[e].main};
    border-radius: ${o.border.radius.full};

    ${r!=="none"&&Pd[r]}
    ${Id[t]}
    ${n&&Md.isDisabled}
    ${i!=="none"&&Td[i]}

    &:hover {
      filter: contrast(90%);
    }
  `}
`;var q=_react.forwardRef.call(void 0, (s,d)=>{var a=s,{bgColor:o="white",size:r="md",color:e="grey",isLoading:t=!1,isDisabled:n=!1,shadow:i="none",children:l}=a,p=b(a,["bgColor","size","color","isLoading","isDisabled","shadow","children"]);return _react2.default.createElement(Di,u({ref:d,bgColor:o,color:e,size:r,disabled:n,shadow:i},p),t?_react2.default.createElement(so,{size:"sm"}):l)});var Ze=_styledcomponents2.default.button`
  ${({theme:o})=>_styledcomponents.css`
    all: unset;

    cursor: pointer;
    color: ${o.font.color.light};
    transition: 0.15s;

    &:hover {
      color: ${o.font.color.main};
    }
  `}
`,Lr=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    display: inline-flex;
    align-items: center;
    gap: ${({theme:r})=>r.space.sm};
    word-break: break-all;
    color: ${o.font.color.light};

    > * {
      line-height: 1;
    }

    &:first-child {
      font-size: ${o.font.size.xsm};
    }

    &:nth-child(2) {
      font-size: ${o.font.size.sm};
      font-weight: ${o.font.weight.md};
    }
  `}
`,Ar={hasBorderBottom:_styledcomponents.css`
    ${({theme:o})=>_styledcomponents.css`
      padding-bottom: ${o.space.md};
      padding-right: ${o.space.lg};
      border-bottom: 1px solid ${o.colors.grey[100]};
    `}
  `,isCopied:_styledcomponents.css`
    ${Ze} {
      color: ${({theme:o})=>o.colors.secondary.main};
    }
  `,isFullWidth:_styledcomponents.css`
    width: 100%;
  `,isInvert:_styledcomponents.css`
    ${Lr} {
      &:first-child {
        order: 2;
      }

      &:nth-child(2) {
        order: 1;
      }
    }
  `},Ad={default:_styledcomponents.css``,primary:_styledcomponents.css``},Ge=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    transform: translateY(1px);

    display: inline-flex;
    align-items: center;
    gap: ${o.space.xsm};

    opacity: 0;

    svg {
      width: ${o.font.size.lg};
      height: ${o.font.size.lg};
    }
  `}
`,Hi=_styledcomponents2.default.div`
  ${({theme:o,hasBorderBottom:r,isCopied:e,isFullWidth:t,isInvert:n,hasActions:i,color:l})=>_styledcomponents.css`
    display: flex;
    flex-direction: column;
    gap: ${o.space.xsm};

    ${Ad[l]}
    ${e&&Ar.isCopied}
    ${n&&Ar.isInvert}
    ${t&&Ar.isFullWidth}
    ${r&&Ar.hasBorderBottom}

    ${i&&_styledcomponents.css`
      &:hover {
        ${Ge} {
          opacity: 1;
        }
      }
    `}
  `}
`;function W3({label:o,value:r,actions:e,copyText:t,color:n="default",isInvert:i=!1,isFullWidth:l=!1,hasBorderBottom:p=!1}){let[d,s]=_react.useState.call(void 0, !1),a=!!t,m=!!e||a;function c(h){return ur(this,null,function*(){h.stopPropagation(),!d&&_utils.copyToClipboard.call(void 0, t).then(()=>{s(!0)})})}return _react.useEffect.call(void 0, ()=>{d&&setTimeout(()=>{s(!1)},3e3)},[d]),_react2.default.createElement(Hi,{color:n,isCopied:d,isInvert:i,hasActions:m,isFullWidth:l,hasBorderBottom:p},_react2.default.createElement(Lr,null,o),_react2.default.createElement(Lr,null,r||"-",m&&_react2.default.createElement(Ge,null,a&&_react2.default.createElement(Ze,{onClick:c},d?_react2.default.createElement(_solid3.Square2StackIcon,null):_react2.default.createElement(_outline.Square2StackIcon,null)),e)))}var _reactdropdownmenu = require('@radix-ui/react-dropdown-menu'); var Er = _interopRequireWildcard(_reactdropdownmenu); var W = _interopRequireWildcard(_reactdropdownmenu);var Ni=_styledcomponents2.default.call(void 0, W.Root)``,je=_styledcomponents2.default.call(void 0, W.Portal)``,_i=_styledcomponents.css`
  ${({theme:o})=>_styledcomponents.css`
    min-width: 220px;

    border-radius: ${o.border.radius.md};
    background: ${o.colors.white.main};
    box-shadow: 0px 10px 38px -10px rgba(22, 23, 24, 0.35),
      0px 10px 20px -15px rgba(22, 23, 24, 0.2);
  `}
`,Od=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    color: ${o.font.color.main};
  `}
`,Dr=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    line-height: 0;
    color: ${o.font.color.main};
  `}
`,Oi=({disabled:o})=>_styledcomponents.css`
  ${({theme:r})=>_styledcomponents.css`
    padding-inline: ${r.space.md};
    padding-block: 12px;
    display: flex;
    align-items: center;
    justify-content: start;

    gap: ${r.space.sm};

    outline: none;
    cursor: pointer;
    color: ${r.font.color.main};
    font-size: ${r.font.size.md};
    font-weight: ${r.font.weight.sm};
    border-radius: ${r.border.radius.xsm};

    svg {
      ${_polished.size.call(void 0, "16px")}
    }

    ${o&&_styledcomponents.css`
      opacity: 0.4;
      pointer-events: none;
    `}

    &:hover {
      color: ${r.colors.secondary.main};
      background-color: ${r.colors.primary.light};

      ${Od||Dr} {
        color: ${r.font.color.light};
      }
    }
  `}
`,Wi=_styledcomponents2.default.call(void 0, W.Content)`
  ${_i}
  z-index: ${({theme:o})=>o.layers.menu};
`,Vi=_styledcomponents2.default.call(void 0, W.SubContent)`
  ${_i}
`,qe=_styledcomponents2.default.call(void 0, W.Item)`
  ${({disabled:o})=>_styledcomponents.css`
    ${Oi({disabled:o})}
  `}
`,Zi=_styledcomponents2.default.call(void 0, W.SubTrigger)`
  ${({disabled:o})=>_styledcomponents.css`
    ${Oi({disabled:o})}
  `}
`,Gi=_styledcomponents2.default.call(void 0, W.Arrow)`
  fill: ${({theme:o})=>o.colors.white.main};
`,Xe=_styledcomponents2.default.call(void 0, W.Separator)`
  ${({theme:o})=>_styledcomponents.css`
    height: 1px;
    display: block;

    background-color: ${o.colors.grey[150]};
  `}
`;function J3({items:o,children:r,align:e="center"}){return _react2.default.createElement(Ni,null,_react2.default.createElement(Er.Trigger,{asChild:!0},r),!!o&&_react2.default.createElement(je,null,_react2.default.createElement(Wi,{sideOffset:5,align:e},o.map(({text:t,onClick:n,slot:i,separator:l,isDisabled:p,isHidden:d,subitems:s},a)=>s||d?null:l?_react2.default.createElement(Xe,{key:`separator-${a}`}):_react2.default.createElement(qe,{key:`item-${a}`,onClick:m=>{m.stopPropagation(),n==null||n()},disabled:p},i&&_react2.default.createElement(Dr,null,i),t)),o.map(({text:t,onClick:n,isDisabled:i,isHidden:l,subitems:p},d)=>!p||l?null:_react2.default.createElement(Er.Sub,{key:`sub-${d}`},_react2.default.createElement(Zi,{onClick:s=>{s.stopPropagation(),n==null||n()},disabled:i},t," ",_react2.default.createElement(_solid3.ChevronRightIcon,null)),_react2.default.createElement(je,null,_react2.default.createElement(Vi,{sideOffset:10},p.map(({text:s,isDisabled:a,slot:m,separator:c,onClick:h},f)=>c?_react2.default.createElement(Xe,null):_react2.default.createElement(qe,{key:`subitem-${f}`,onClick:g=>{g.stopPropagation(),h==null||h()},disabled:a},m&&_react2.default.createElement(Dr,null,m),s)))))),_react2.default.createElement(Gi,null))))}var qi=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: ${o.space.sm};
    padding: ${o.space.md} ${o.space.lg};
    border-top: 1px solid ${o.colors.grey[100]};
  `}
`,Zd={sm:_styledcomponents.css`
    width: 380px;
  `,md:_styledcomponents.css`
    width: 500px;
  `,lg:_styledcomponents.css`
    width: 720px;
  `,xlg:_styledcomponents.css`
    width: 968px;
  `,full:_styledcomponents.css`
    width: 100%;
    height: 100%;
    max-height: 100vh;
    overflow-y: auto;

    border-radius: 0;
  `},Gd={hasBackdrop:_styledcomponents.css`
    overflow-y: auto;
    background-color: ${({theme:o})=>o.colors.overlay.main};
  `},Ue=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    position: relative;
    z-index: 1000;

    display: flex;
    flex-direction: column;
    margin-block: ${o.space.lg};

    border-radius: ${o.border.radius.lg};
    background-color: ${o.colors.white.main};

    animation: 0.5s slide-up;
  `}
`,Xi=_styledcomponents2.default.div`
  ${({size:o,hasBackdrop:r})=>_styledcomponents.css`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: ${({theme:e})=>e.layers.dialog};

    display: grid;
    place-items: center;

    ${r&&Gd.hasBackdrop}

    ${Ue} {
      ${_styledmediaquery2.default.greaterThan("small")`
        ${Zd[o]}
      `}

      ${_styledmediaquery2.default.lessThan("medium")`
        width: 96%;
      `}
    }
  `}
`,Ui=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${o.space.lg};
    gap: ${o.space.sm};

    font-weight: bold;
    font-size: ${o.font.size.xlg};
  `}
`,Yi=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    padding-inline: ${o.space.lg};
    padding-bottom: ${o.space.xlg};
  `}
`;function oe({children:o,isOpen:r,size:e,hasBackdrop:t=!1}){return xr(r),typeof r!="undefined"&&!r?null:_react2.default.createElement(Xi,{size:e,hasBackdrop:t},o)}function re({children:o}){return _react2.default.createElement(Yi,null,o)}function ee({children:o}){return _react2.default.createElement(Ue,null,o)}function te({children:o}){return _react2.default.createElement(qi,null,o)}function ne({children:o}){return _react2.default.createElement(Ui,null,o)}var Qi=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    position: relative;
    width: 220px;
    max-height: 90vh;
    padding-bottom: ${o.space.md};
    background-color: ${o.colors.white.main};
    border-radius: ${o.border.radius.md};
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05),
      0px 0px 0px 1px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    z-index: ${o.layers.menu};
    animation: 0.5s slide-right;

    ${_styledmediaquery2.default.lessThan("large")`
      height: 100%;
      max-height: fit-content;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    `}
  `}
`,Ji=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    padding: ${o.space.lg};
    border-bottom: 1px solid ${o.colors.grey[100]};
  `}
`,Ki=_styledcomponents2.default.div`
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.04);
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.1);
  }

  ::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.15);
  }
`,Ye=_styledcomponents2.default.div``,dr=_styledcomponents2.default.button`
  ${({theme:o,isActive:r})=>_styledcomponents.css`
    all: unset;

    width: 100%;
    display: flex;
    align-items: center;
    gap: ${o.space.sm};
    padding: ${o.space.sm} ${o.space.lg};
    cursor: pointer;
    margin-bottom: ${o.space.xsm};
    box-sizing: border-box;

    &:first-child {
      margin-top: ${o.space.xsm};
    }

    ${r&&_styledcomponents.css`
      background-color: rgba(0, 0, 0, 0.04);
    `}

    &:hover {
      background-color: rgba(0, 0, 0, 0.04);

      > svg {
        color: rgba(0, 0, 0, 0.6);
      }
    }

    > svg {
      height: 14px;
      color: rgba(0, 0, 0, 0.4);
    }
  `}
`,Ri=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    ${dr} {
      padding: ${o.space.sm} ${o.space.xlg};
    }
  `}
`,oa=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    margin-top: auto;
    border-top: 1px solid ${o.colors.grey[100]};
    padding-top: ${o.space.sm};
  `}
`;function Ai({logo:o,menu:r,footerLinks:e,footerRender:t,onFiredAction:n}){let[i,l]=_react.useState.call(void 0, []);function p(s){l(a=>a.includes(s)?a.filter(m=>m!==s):[...a,s])}function d(s){s==null||s(),n==null||n()}return _react2.default.createElement(Qi,null,_react2.default.createElement(Ji,null,o),_react2.default.createElement(Ki,null,r.map(({icon:s,text:a,onClick:m,items:c,isHide:h},f)=>{let g=`menu-${f}`,y=i.includes(g);if(!h)return _react2.default.createElement(Ye,{key:g},_react2.default.createElement(dr,{isActive:y,onClick:m?d.bind(null,m):p.bind(null,g)},s,_react2.default.createElement(v,null,a),c&&(y?_react2.default.createElement(_solid.ChevronDownIcon,null):_react2.default.createElement(_solid.ChevronRightIcon,null))),c&&y&&_react2.default.createElement(Ri,null,c.map(($,D)=>_react2.default.createElement(dr,{key:D,onClick:d.bind(null,$.onClick)},$.icon,_react2.default.createElement(v,null,"\u2022 ",$.text)))))})),(e||t)&&_react2.default.createElement(oa,null,e&&_react2.default.createElement("div",null,e.map(({text:s,icon:a,onClick:m},c)=>_react2.default.createElement(Ye,{key:c},_react2.default.createElement(dr,{onClick:m},a,_react2.default.createElement(v,null,s))))),t&&_react2.default.createElement("div",null,t)))}var Hr=_styledcomponents2.default.call(void 0, j)`
  ${({isSelected:o})=>_styledcomponents.css`
    border-color: transparent;
    background-color: transparent;

    &:hover {
      border-color: rgba(0, 0, 0, 0.08);
    }

    ${o&&_styledcomponents.css`
      transition: all 0.15s;

      background-color: rgba(0, 0, 0, 0.08);
    `}
  `}
`,ea=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    display: inline-flex;
    gap: ${o.space.xsm};
  `};
`;var Je="LEFT",Ke="RIGHT";function Nr(o,r,e=1){let t=o,n=[];for(;t<=r;)n.push(t),t+=e;return n}function ta(o,r,e){let t=e*2+3,n=t+2;if(o>n){let i=[],l=r-e,p=r+e,d=o-1,s=l>2?l:2,a=p<d?p:d;i=Nr(s,a);let m=i.length,c=t-m-1,h=s>2,f=a<d,g=Je,y=Ke;if(h&&!f){let $=Nr(s-c,s-1);i=[g,...$,...i]}else if(!h&&f){let $=Nr(a+1,a+c);i=[...i,...$,y]}else h&&f&&(i=[g,...i,y]);return[1,...i,o]}return Nr(1,o)}function _r({count:o,pageLimit:r=8,siblingCount:e,onChanged:t,onChangedScrollTo:n}){let[i,l]=_react.useState.call(void 0, 1),[p,d]=_react.useState.call(void 0, ()=>Math.ceil(o/r));function s(f){let g=Number(f);isNaN(g)&&i===g||(t(g),l(g),n!=null&&n.current&&window.scroll({behavior:"smooth",top:n.current.offsetTop-_r.SCROLL_OFFSET}))}function a(f){s(f)}function m(f){f.preventDefault(),s(i-e*2-1)}function c(f){f.preventDefault(),s(i+e*2+1)}let h=ta(p,i,e);return _react.useEffect.call(void 0, ()=>{d(Math.ceil(o/r))},[o,r]),!o||p===1?_react2.default.createElement(_react2.default.Fragment,null):_react2.default.createElement(ea,null,h.map((f,g)=>f===Je?_react2.default.createElement(Hr,{key:`left-button-${g}`,size:"sm",variant:"contained",color:"white",onClick:y=>m(y),icon:_react2.default.createElement(_solid3.ChevronLeftIcon,null)}):f===Ke?_react2.default.createElement(Hr,{key:`right-button-${g}`,size:"sm",variant:"contained",color:"white",onClick:y=>c(y),icon:_react2.default.createElement(_solid3.ChevronRightIcon,null)}):_react2.default.createElement(Hr,{key:`page-button-${g}`,size:"sm",isSelected:i===f,color:"white",variant:"contained",onClick:y=>{y.preventDefault(),a(Number(f))}},f)))}(r=>r.SCROLL_OFFSET=20)(_r||(_r= exports.Paginator ={}));var aa=_styledcomponents2.default.div`
  padding: 6px;

  border: 1px solid ${({theme:o})=>o.colors.neutralDark.light};
  border-radius: ${({theme:o})=>o.border.radius.md};

  position: relative;

  display: flex;
  align-items: center;

  color: ${({theme:o})=>o.colors.secondary.main};

  > svg,
  > img {
    width: 32px;
    height: 32px;
    object-fit: cover;
  }
`,sa=_styledcomponents2.default.div`
  ${({theme:o,color:r})=>_styledcomponents.css`
    position: absolute;
    top: -2px;
    left: -4px;

    color: ${o.colors[r].main};
    border-radius: ${o.border.radius.full};
    background-color: ${o.colors.white.main};
    line-height: 0;

    svg {
      width: 16px;
      height: 16px;
    }
  `}
`;function U5({data:o,size:r="md",variant:e="default",icon:t,status:n,actions:i,onAdd:l,onEdit:p,onDelete:d,isInverted:s=!1}){let a=_react.useMemo.call(void 0, ()=>{if(n)return{success:{color:"primary",icon:_react2.default.createElement(_solid.CheckCircleIcon,null)},error:{color:"danger",icon:_react2.default.createElement(_solid.ExclamationCircleIcon,null)},warning:{color:"warning",icon:_react2.default.createElement(_solid.ExclamationTriangleIcon,null)}}[n]},[n]),m=_react.useMemo.call(void 0, ()=>{if(e)return{default:{titleColor:"secondary",subtitleColor:"light"},light:{titleColor:"light",subtitleColor:"light"},success:{titleColor:"primary",subtitleColor:"light"},error:{titleColor:"danger",subtitleColor:"light"},warning:{titleColor:"warning",subtitleColor:"light"}}[e]},[e]),c=_react.useMemo.call(void 0, ()=>({sm:{card:"sm",title:"md",subtitle:"xsm",button:"sm"},md:{card:"md",title:"lg",subtitle:"sm",button:"md"}})[r],[r]),h=Object.entries({onAdd:l,onEdit:p,onDelete:d}).filter(([f,g])=>!!g);return _react2.default.createElement(X,{isBordered:!0,elevation:"md",color:"white",padding:c.card},_react2.default.createElement(x,{display:"flex",alignItems:"center",justifyContent:"space-between",spacing:"md"},_react2.default.createElement(x,{display:"flex",alignItems:"center",spacing:"md",flex:"1"},_react2.default.createElement(aa,null,t||_react2.default.createElement(_outline.PhotoIcon,{color:J.colors.grey[150]}),a&&_react2.default.createElement(sa,{color:a==null?void 0:a.color},a.icon)),_react2.default.createElement(x,{display:"flex",flexDirection:s?"column-reverse":"column",flex:"1"},_react2.default.createElement(v,{color:m==null?void 0:m.titleColor,weight:"bolder",size:c.title,lineHeight:"1.2"},o.title),o.subtitle&&_react2.default.createElement(v,{color:m==null?void 0:m.subtitleColor,size:c.subtitle},o.subtitle))),(i==null?void 0:i.length)&&_react2.default.createElement(x,{display:"flex",alignItems:"center",spacing:"sm"},i.map((f,g,y)=>{let $=g===y.length-1&&y.length>1;return _react2.default.createElement(q,{key:`preview-card-action-${g}`,type:"button",onClick:f.onClick,bgColor:$?"grey":"white",size:c.button},f.icon)})),h.length>0&&_react2.default.createElement(x,{display:"flex",alignItems:"center",spacing:"sm"},h.map(([f,g],y,$)=>{let D={onAdd:_react2.default.createElement(_outline.PlusIcon,null),onEdit:_react2.default.createElement(_outline.PencilIcon,null),onDelete:_react2.default.createElement(_outline.XMarkIcon,null)}[f],E=y===$.length-1&&$.length>1;return _react2.default.createElement(q,{key:`preview-predefined-card-action-${f}`,type:"button",onClick:g,bgColor:E?"grey":"white",size:c.button},D)}))))}var pa=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    position: relative;

    width: 100%;
    height: 6px;
    border-radius: ${o.border.radius.sm};

    background-color: ${o.colors.grey.main};
  `}
`,fc={primary:_styledcomponents.css`
    ${({theme:o})=>_styledcomponents.css`
      background-color: ${o.colors.primary.main};
    `}
  `,grey:_styledcomponents.css`
    ${({theme:o})=>_styledcomponents.css`
      background-color: ${o.colors.grey.main};
    `}
  `,secondary:_styledcomponents.css`
    ${({theme:o})=>_styledcomponents.css`
      background-color: ${o.colors.secondary.main};
    `}
  `},da=_styledcomponents2.default.div`
  ${({theme:o,width:r,color:e})=>_styledcomponents.css`
    position: absolute;
    top: 0;
    left: 0;

    width: ${r}%;
    height: 100%;
    border-radius: ${o.border.radius.sm};

    transition: width 0.5s;

    ${fc[e]}
  `}
`;function qn({value:o=0,color:r="primary"}){return _react2.default.createElement(pa,null,_react2.default.createElement(da,{width:o>100?100:o,color:r}))}var ma={danger:_styledcomponents.css`
    ${({theme:o})=>o.colors.danger.main};
  `,primary:_styledcomponents.css`
    ${({theme:o})=>o.colors.primary.main};
  `,warning:_styledcomponents.css`
    ${({theme:o})=>o.colors.warning.main};
  `,grey:_styledcomponents.css`
    ${({theme:o})=>o.colors.grey.main};
  `,warningDark:_styledcomponents.css`
    ${({theme:o})=>o.colors.warning.dark};
  `,dangerDark:_styledcomponents.css`
    ${({theme:o})=>o.colors.danger.dark};
  `,info:_styledcomponents.css`
    ${({theme:o})=>o.colors.info.main};
  `},ga=_styledcomponents2.default.div`
  width: fit-content;
  height: 50px;

  display: flex;
`,fa=_styledcomponents2.default.div`
  ${({theme:o,variant:r})=>_styledcomponents.css`
    width: 3px;
    height: 50px;
    border-radius: 100px;
    margin-right: ${o.space.md};

    background-color: ${ma[r]};
  `}
`,ua=_styledcomponents2.default.div`
  ${({theme:o,variant:r})=>_styledcomponents.css`
    width: 20px;
    height: 20px;
    display: flex;
    margin-left: ${o.space.sm};

    color: ${ma[r]};

    > svg {
      height: 100%;
    }
  `}
`,xa=_styledcomponents2.default.div`
  display: flex;
  align-items: center;
`;var yc={up:_react2.default.createElement(_outline.ChevronUpIcon,null),down:_react2.default.createElement(_outline.ChevronDownIcon,null)};function lb({variant:o="primary",icon:r,title:e,value:t}){return _react2.default.createElement(ga,null,_react2.default.createElement(fa,{variant:o}),_react2.default.createElement("div",null,_react2.default.createElement(v,{size:"xsm",color:"dark"},e),_react2.default.createElement(xa,null,_react2.default.createElement(v,{size:"2xl",color:o,weight:700},t),_react2.default.createElement(ua,{variant:o},typeof r=="string"?yc[r]:r))))}var Mc=_styledsystem.compose.call(void 0, _styledsystem.layout,_styledsystem.space,_styledsystem.flexbox,_styledsystem.grid,_styledsystem.gridTemplateColumns,_styledsystem.position),ba=_styledcomponents2.default.div`
  ${({theme:o,width:r,isLoaded:e})=>_styledcomponents.css`
    width: ${r};
    display: inline-flex;

    border-radius: ${o.border.radius.xsm};
    background-color: ${o.colors.grey[150]};
    animation: ${!e&&"skeleton-loading 1s linear infinite alternate"};

    ${Mc}

    @keyframes skeleton-loading {
      0% {
        opacity: 1;
      }

      50% {
        opacity: 0.4;
      }

      100% {
        opacity: 1;
      }
    }
  `}
`;function xb(n){var i=n,{children:o,isLoaded:r=!1,width:e=o?"auto":"100%"}=i,t=b(i,["children","isLoaded","width"]);return _react2.default.createElement(ba,u({width:e,isLoaded:r},t),o)}var Fc={sm:_styledcomponents.css`
    width: 16px;
    height: 16px;
  `,md:_styledcomponents.css`
    width: 32px;
    height: 32px;
  `,lg:_styledcomponents.css`
    width: 64px;
    height: 64px;
  `},ha=_styledcomponents2.default.div`
  ${({theme:o,size:r,color:e})=>_styledcomponents.css`
    line-height: 0;

    svg {
      animation: spinner-rotate 2s linear infinite;

      ${Fc[r]}

      & .path {
        stroke-linecap: round;
        animation: spinner-dash 1.5s ease-in-out infinite;

        stroke: ${o.colors[e].main};
      }
    }

    @keyframes spinner-rotate {
      100% {
        transform: rotate(360deg);
      }
    }

    @keyframes spinner-dash {
      0% {
        stroke-dasharray: 1, 150;
        stroke-dashoffset: 0;
      }
      50% {
        stroke-dasharray: 90, 150;
        stroke-dashoffset: -35;
      }
      100% {
        stroke-dasharray: 90, 150;
        stroke-dashoffset: -124;
      }
    }
  `}
`;function so({color:o="primary",size:r="md"}){return _react2.default.createElement(ha,{color:o,size:r},_react2.default.createElement("svg",{className:"spinner",viewBox:"0 0 50 50"},_react2.default.createElement("circle",{className:"path",cx:"25",cy:"25",r:"20",fill:"none",strokeWidth:"5"})))}var Sa=_react.createContext.call(void 0, {activeStep:-1,setActiveStep:()=>{}}),Ca=_react.createContext.call(void 0, {step:-1,isCompleted:!1});function va(){return _react.useContext.call(void 0, Sa)}function Zr(){return _react.useContext.call(void 0, Ca)}function Mb({children:o,activeStep:r=-1}){let[e,t]=_react.useState.call(void 0, r||-1);return _react.useEffect.call(void 0, ()=>{t(r)},[r]),_react2.default.createElement(Sa.Provider,{value:{activeStep:e,setActiveStep:t}},_react2.default.createElement(x,{display:"flex",justifyContent:"space-between"},_react.Children.map(o,(n,i)=>_react2.default.createElement(Ca.Provider,{value:{step:i,isCompleted:i<=e}},_react2.default.cloneElement(n)))))}var wa=_styledcomponents2.default.call(void 0, x)`
  ${({subStepsQuantity:o,currentSubStep:r})=>_styledcomponents.css`
    position: absolute;
    max-width: ${o>0?"90%":"100%"};
    width: calc(${r+1}00% / ${o});
    top: -30px;
    z-index: 4;
  `}
`,rt=_styledcomponents2.default.call(void 0, x)`
  position: absolute;
  white-space: nowrap;
  transform: translateX(-50%);
  left: 100%;
  z-index: 4;
`,ka=_styledcomponents2.default.call(void 0, x)`
  ${({showSubStepCircle:o,arrowColor:r})=>_styledcomponents.css`
    position: absolute;
    left: calc(50% - 5px);
    bottom: -5px;

    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid ${r};

    ${o&&_styledcomponents.css`
      ::after {
        position: absolute;
        top: 5px;
        left: calc(50% - 5px);
        content: "";
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: ${r};

        background: linear-gradient(
            45deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0) 43%,
            #fff 45%,
            #fff 55%,
            rgba(0, 0, 0, 0) 57%,
            rgba(0, 0, 0, 0) 100%
          ),
          linear-gradient(
            135deg,
            ${r} 0%,
            ${r} 43%,
            #fff 45%,
            #fff 55%,
            ${r} 57%,
            ${r} 100%
          );
        )
      }
    `}
  `}
`,Pa=_styledcomponents2.default.call(void 0, x)`
  ${({theme:{colors:o},isCompleted:r,isCurrentStep:e,subStepsQuantity:t,currentSubStep:n})=>_styledcomponents.css`
    ::before {
      position: absolute;
      content: "";
      border-bottom: 2px solid ${o.grey[150]};
      width: 100%;
      top: 5px;
      left: -50%;
      z-index: 2;

      ${r&&_styledcomponents.css`
        border-color: ${o.secondary.main};
      `}
    }

    ::after {
      position: absolute;
      content: "";
      max-width: ${t>0?"90%":"100%"};
      top: 5px;
      left: 50%;
      z-index: 3;

      ${t>0&&_styledcomponents.css`
        width: calc(${n+1}00% / ${t});
      `}

      ${e&&_styledcomponents.css`
        border-bottom: 2px solid ${o.secondary.main};
      `}
    }

    :first-child::before {
      content: none;
    }

    :last-child::after {
      content: none;
    }

    :last-child {
      ${rt} {
        display: none;
      }
    }
  `}
`;function _b({children:o,currentSubStep:r=-1,subSteps:e=[],isInvalid:t=!1}){let{colors:n}=_styledcomponents.useTheme.call(void 0, ),{activeStep:i}=va(),{step:l,isCompleted:p}=Zr(),d=r>-1&&r<e.length,s=l===i,a=t?n.danger.main:n.secondary.main;return _react2.default.createElement(Pa,{isCompleted:p,isCurrentStep:s,currentSubStep:r,subStepsQuantity:e.length,display:"flex",position:"relative",flexDirection:"column",alignItems:"center",mt:4,flex:1},r>-1&&r<e.length&&_react2.default.createElement(x,null,s&&_react2.default.createElement(wa,{currentSubStep:r,isCurrentStep:s,subStepsQuantity:e.length},_react2.default.createElement(rt,{padding:"0 8px",borderRadius:"50px",background:a},_react2.default.createElement(ka,{showSubStepCircle:t,arrowColor:a}),_react2.default.createElement(v,{color:"white",weight:600},e[r])))),_react2.default.createElement(x,{display:"flex",width:12,height:12,borderRadius:"50%",background:t&&s&&!d?n.danger.main:p?n.secondary.main:n.grey[150],mb:2,zIndex:4}),o)}function qb(e){var t=e,{children:o}=t,r=b(t,["children"]);let{isCompleted:n}=Zr();return _react2.default.createElement(x,{mx:1,textAlign:"center"},_react2.default.createElement(v,u({weight:600,size:"sm",color:n?"secondary":"light"},r),o))}var Ta=_styledcomponents2.default.call(void 0, X).attrs({padding:"none"})`
  display: grid;
  gap: ${({theme:o})=>o.space.md};
`,jo=_styledcomponents2.default.call(void 0, X).attrs({borderRadius:"none"})`
  ${({theme:o,isClickable:r,gridTemplateAreas:e})=>_styledcomponents.css`
    display: grid;
    gap: ${o.space.sm};
    font-size: ${o.font.size.md};

    padding-inline: ${o.space.md};

    grid-template-areas: ${e};

    &:not(:last-of-type) {
      border-bottom: 1px solid ${o.colors.grey[100]};
    }
    &:first-of-type {
      border-radius: 12px 12px 0 0;
    }

    &:last-of-type {
      border-radius: 0 0 12px 12px;
    }

    ${r&&_styledcomponents.css`
      &:hover {
        cursor: pointer;
        transition: all 0.15s;

        filter: brightness(96%);
      }
    `}
  `}
`,Ma=_styledcomponents2.default.call(void 0, X).attrs({color:"grey",isBordered:!0,padding:"none"})`
  ${({theme:o,gridColumns:r,alignItems:e,mobileWidth:t,gridTemplateAreas:n})=>_styledcomponents.css`
    display: flex;
    flex-direction: column;
    overflow-x: auto;
    padding-inline: ${o.space.md};

    ${jo} {
      align-items: ${e};
      grid-template-columns: ${r};
      grid-template-areas: ${n};
    }

    ${jr},
    ${tt},
    ${nt},
    ${et} {
      ${_styledmediaquery2.default.lessThan("medium")`
      width: ${t.toString()}px;
      `}
    }
    ${Vc}
  `};
`,jr=_styledcomponents2.default.call(void 0, X).attrs({color:"grey",padding:"none"})`
  ${jo} {
    padding-block: ${({theme:o})=>o.space.md};

    background-color: transparent;
    font-size: ${({theme:o})=>o.font.size.sm};
    font-weight: ${({theme:o})=>o.font.weight.md};
    color: ${({theme:o})=>o.colors.neutralDark.main};
  }
`,Vc=_styledcomponents.css`
  ${({theme:o})=>_styledsystem.variant.call(void 0, {prop:"variant",variants:{inverse:{border:"none",borderRadius:0,backgroundColor:o.colors.white.main,padding:0,[`${jr}`]:{backgroundColor:o.colors.white.main},[`${jo}`]:{backgroundColor:o.colors.neutral.light,"&:not(:last-of-type)":{borderBottom:`2px solid ${o.colors.white.main}`}}}}})}
`,et=_styledcomponents2.default.call(void 0, X).attrs({padding:"md"})``,Ba=_styledcomponents2.default.call(void 0, X).attrs({padding:"md"})``,tt=_styledcomponents2.default.div`
  ${({theme:o,hasScroll:r})=>_styledcomponents.css`
    padding-bottom: ${o.space.md};

    ${jo} {
      padding-block: ${({theme:e})=>e.space.md};
      font-size: ${({theme:e})=>e.font.size.md};
    }

    ${r&&_styledcomponents.css`
      overflow-y: auto;
      max-height: 219px;
      padding-right: 8px;
    `}

    ::-webkit-scrollbar {
      width: 6px;
    }

    ::-webkit-scrollbar-thumb {
      background: rgba(204, 204, 204, 1);
      border-radius: 8px;
    }
  `}
`,nt=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    display: flex;
    align-items: center;
    gap: ${o.space.md};
    padding: ${o.space.md};
    padding-top: 0;
    justify-content: space-between;
  `}
`,za=_styledcomponents2.default.div`
  display: flex;
  align-items: center;
  gap: ${({theme:o})=>o.space.sm};
`,qr=_styledcomponents2.default.div`
  ${({justifyContent:o,gridArea:r})=>_styledcomponents.css`
    display: flex;
    justify-content: ${o};
    grid-area: ${r};
  `}
`,Aa=_styledcomponents2.default.div`
  position: relative;

  display: flex;

  user-select: none;
  cursor: pointer;

  &:hover {
    opacity: 0.6;
    transition: 0.15s;
  }

  > svg {
    position: absolute;
    top: 50%;
    right: -24px;
    transform: translateY(-50%);
  }
`;function Tn({children:o,gridColumns:r,variant:e="normal",mobileWidth:t=1e3,alignItems:n="center",gridTemplateAreas:i}){return _react2.default.createElement(Ma,{variant:e,mobileWidth:t,gridColumns:r,alignItems:n,gridTemplateAreas:i},o)}function Mn({children:o}){return _react2.default.createElement(Ta,{children:o})}function $e({children:o,onClick:r,id:e,gridTemplateAreas:t}){return _react2.default.createElement(jo,{id:e,isClickable:!!r,onClick:r,children:o,gridTemplateAreas:t})}function Bn({children:o,isLoading:r=!1,loadingText:e="Aguarde, carregando...",hasScroll:t=!1}){return _react2.default.createElement(tt,{hasScroll:t},r?_react2.default.createElement(et,null,_react2.default.createElement(x,{display:"flex",alignItems:"center",spacing:"md"},_react2.default.createElement(so,{size:"sm"}),_react2.default.createElement(v,{color:"secondary",size:"md"},e))):o)}function zn({children:o}){return _react2.default.createElement(nt,{children:o})}function An({children:o}){return _react2.default.createElement(jr,{children:o})}function Fn({children:o}){return _react2.default.createElement(za,{children:o})}function Se({children:o,justifyContent:r="flex-start",gridArea:e}){return _react2.default.createElement(qr,{justifyContent:r,children:o,gridArea:e})}function Ln({children:o,onClick:r,sortDirection:e}){return _react2.default.createElement(Aa,{onClick:r},_react2.default.createElement(qr,{children:o}),e&&{asc:_react2.default.createElement(_solid.ChevronUpIcon,{width:18}),desc:_react2.default.createElement(_solid.ChevronDownIcon,{width:18})}[e])}function Dn({message:o="Nenhum item encontrado."}){return _react2.default.createElement(Ba,null,_react2.default.createElement(x,{display:"flex",alignItems:"center",spacing:"md"},_react2.default.createElement(v,{color:"secondary",size:"md"},o)))}var La=_styledcomponents2.default.button`
  ${({theme:o,isSelected:r})=>_styledcomponents.css`
    all: unset;
    position: relative;

    height: 31px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${o.colors.white.main};
    cursor: pointer;
    color: ${o.font.color.light};
    white-space: nowrap;
    border-radius: ${o.border.radius.sm};
    padding: 0 12px;
    font-size: ${o.font.size.sm};

    &:hover {
      transition: all 0.15s;

      background-color: ${({theme:e})=>e.colors.grey[50]};
    }

    ${r&&_styledcomponents.css`
      font-weight: ${({theme:e})=>e.font.weight.md};

      color: ${o.font.color.main};
      background-color: ${({theme:e})=>e.colors.grey[100]};
    `}
  `}
`,Da=_styledcomponents2.default.call(void 0, X)`
  ${({isFullWidth:o})=>_styledcomponents.css`
    display: ${o?"flex":"inline-flex"};

    ${_styledmediaquery2.default.lessThan("large")`
      overflow-x: auto;
    `}
  `}
`;function n4({tabs:o,backgroundColor:r="grey",isFullWidth:e=!1}){return _react2.default.createElement(Da,{isFullWidth:e},o.map(({children:t,id:n,onClick:i,isSelected:l,showBadge:p,badgeColor:d="warning"})=>_react2.default.createElement(La,{key:`tab-${n}`,onClick:i,isSelected:l,backgroundColor:r,isFullWidth:e,id:n},p&&_react2.default.createElement(x,{position:"absolute",top:0,right:20},_react2.default.createElement(an,{color:d,size:"sm",marquer:"circle",hasShadow:!0})),t)))}var _reacttooltip = require('@radix-ui/react-tooltip'); var Yr = _interopRequireWildcard(_reacttooltip);var Ha=_styledcomponents2.default.div``,Na=_styledcomponents2.default.call(void 0, Yr.Content)`
  ${({theme:o,bgColor:r})=>_styledcomponents.css`
    z-index: ${o.layers.tooltip};
    padding: ${o.space.sm};
    border-radius: ${o.border.radius.md};

    font-size: ${o.font.size.sm};
    color: ${o.colors.white.main};
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
    background-color: ${o.colors[r].main};
  `}
`,_a=_styledcomponents2.default.call(void 0, Yr.Arrow)`
  ${({theme:o,bgColor:r})=>_styledcomponents.css`
    fill: ${o.colors[r].main};
  `}
`;function ri({children:o,content:r,options:e,bgColor:t="black"}){return _react2.default.createElement(Ha,null,_react2.default.createElement(_reacttooltip.Provider,null,_react2.default.createElement(_reacttooltip.Root,{delayDuration:200},_react2.default.createElement(_reacttooltip.Trigger,{asChild:!0},o),_react2.default.createElement(_reacttooltip.Portal,null,_react2.default.createElement(Na,Z(u({sideOffset:5},e==null?void 0:e.content),{bgColor:t}),r,_react2.default.createElement(_a,{bgColor:t}))))))}var Oa=_styledcomponents2.default.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background-color: ${({theme:o})=>o.colors.overlay.main};
`;function ie(o){return _react2.default.createElement(Oa,u({},o))}var lm={white:_styledcomponents.css`
    ${({theme:o})=>o.colors.white.main};
  `,green:_styledcomponents.css`
    ${({theme:o})=>o.colors.secondary.main};
  `},qo=_styledcomponents2.default.svg`
  ${({color:o})=>_styledcomponents.css`
    height: 100%;

    color: ${lm[o]};
  `}
`,Wa=_styledcomponents2.default.g`
  ${({theme:o})=>_styledcomponents.css`
    color: ${o.colors.secondary.main};
  `}
`,Va=_styledcomponents2.default.g`
  ${({theme:o})=>_styledcomponents.css`
    color: ${o.colors.primary.main};
  `}
`;function Za(){return _react2.default.createElement("svg",{viewBox:"0 0 497 226",fill:"currentColor",xmlns:"http://www.w3.org/2000/svg",role:"img"},_react2.default.createElement("title",null,"Logotipo Verde - Vers\xE3o completa"),_react2.default.createElement(Wa,null,_react2.default.createElement("path",{d:"M43.77 132.56 4 37.8h27.77l25.26 70.4-5.73 1.07 26.51-71.48h27.23L63.3 132.55H43.77v.01ZM159.31 134.35c-10.27 0-19.26-2.09-26.96-6.27-7.7-4.18-13.68-9.91-17.91-17.2-4.24-7.28-6.36-15.58-6.36-24.9 0-7.4 1.19-14.18 3.58-20.33 2.39-6.15 5.73-11.43 10.03-15.85 4.3-4.42 9.4-7.85 15.32-10.3 5.91-2.45 12.39-3.67 19.44-3.67 6.45 0 12.39 1.16 17.82 3.49s10.15 5.61 14.15 9.85c4 4.24 7.08 9.23 9.23 14.96 2.15 5.73 3.16 12 3.05 18.81l-.18 7.88h-76.14l-4.12-15.76h59.29l-3.05 3.22v-3.76c-.24-3.34-1.28-6.27-3.13-8.78-1.85-2.51-4.21-4.51-7.08-6-2.87-1.49-6.03-2.24-9.49-2.24-5.37 0-9.88 1.05-13.52 3.13-3.64 2.09-6.39 5.08-8.24 8.96-1.85 3.88-2.78 8.69-2.78 14.42s1.19 10.54 3.58 14.78 5.82 7.5 10.3 9.76c4.48 2.27 9.76 3.4 15.85 3.4 4.18 0 8-.66 11.46-1.97 3.46-1.31 7.22-3.58 11.29-6.81l12 17.02c-3.34 2.99-7.11 5.55-11.29 7.7a58.461 58.461 0 0 1-12.9 4.84c-4.42 1.07-8.84 1.61-13.26 1.61l.02.01ZM242.53 37.8v94.76h-25.62V37.8h25.62ZM334.19 134.35c-8.24 0-15.67-2.09-22.3-6.27-6.63-4.18-11.82-10-15.59-17.47-3.76-7.46-5.64-15.91-5.64-25.35 0-9.44 1.88-18.03 5.64-25.44 3.76-7.4 8.93-13.26 15.5-17.56 6.57-4.3 14.03-6.45 22.39-6.45 4.42 0 8.69.69 12.81 2.06 4.12 1.37 7.79 3.26 11.02 5.64 3.22 2.39 5.85 5.05 7.88 7.97 2.03 2.93 3.22 5.94 3.58 9.05l-6.45 1.25V0h25.26v132.56h-24l-1.07-21.85 5.02.72c-.12 2.87-1.14 5.67-3.05 8.42s-4.45 5.23-7.61 7.43c-3.17 2.21-6.75 3.94-10.75 5.19-4 1.25-8.21 1.88-12.63 1.88h-.01Zm5.55-21.14c4.9 0 9.11-1.19 12.63-3.58 3.52-2.39 6.3-5.67 8.33-9.85 2.03-4.18 3.05-9.02 3.05-14.51s-1.02-10.54-3.05-14.78-4.81-7.52-8.33-9.85c-3.52-2.33-7.73-3.49-12.63-3.49s-8.78 1.16-12.36 3.49-6.36 5.61-8.33 9.85c-1.97 4.24-2.96 9.17-2.96 14.78 0 5.61.99 10.33 2.96 14.51s4.75 7.46 8.33 9.85c3.58 2.39 7.7 3.58 12.36 3.58ZM455.21 134.35c-10.27 0-19.26-2.09-26.96-6.27-7.7-4.18-13.68-9.91-17.91-17.2-4.24-7.28-6.36-15.58-6.36-24.9 0-7.4 1.19-14.18 3.58-20.33 2.39-6.15 5.73-11.43 10.03-15.85 4.3-4.42 9.4-7.85 15.32-10.3 5.91-2.45 12.39-3.67 19.44-3.67 6.45 0 12.39 1.16 17.82 3.49s10.15 5.61 14.15 9.85c4 4.24 7.08 9.23 9.23 14.96 2.15 5.73 3.16 12 3.05 18.81l-.18 7.88h-76.13l-4.12-15.76h59.29l-3.05 3.22v-3.76c-.24-3.34-1.28-6.27-3.13-8.78-1.85-2.51-4.21-4.51-7.08-6-2.87-1.49-6.03-2.24-9.49-2.24-5.37 0-9.88 1.05-13.52 3.13-3.64 2.09-6.39 5.08-8.24 8.96-1.85 3.88-2.78 8.69-2.78 14.42s1.19 10.54 3.58 14.78 5.82 7.5 10.3 9.76c4.48 2.27 9.76 3.4 15.85 3.4 4.18 0 8-.66 11.46-1.97 3.46-1.31 7.22-3.58 11.29-6.81l12 17.02c-3.34 2.99-7.11 5.55-11.29 7.7a58.461 58.461 0 0 1-12.9 4.84c-4.42 1.07-8.84 1.61-13.26 1.61l.01.01ZM285.61 34.85c-19.76 0-35.78 16.02-35.78 35.78v3.83h4.32c19.76 0 35.78-16.02 35.78-35.78v-3.83h-4.32Z",fill:"currentColor"})),_react2.default.createElement(Va,null,_react2.default.createElement("path",{d:"M14.627 215.665c-2.57 0-4.898-.51-6.982-1.53-2.084-1.064-3.746-2.615-4.987-4.655-1.242-2.083-1.862-4.61-1.862-7.581.088-2.97.731-5.519 1.928-7.647 1.241-2.128 2.882-3.768 4.921-4.921 2.084-1.153 4.456-1.729 7.116-1.729 2.704 0 5.01.532 6.916 1.596 1.95 1.02 3.457 2.372 4.521 4.056 1.064 1.641 1.663 3.348 1.796 5.121h-6.251c-.665-3.281-2.926-4.921-6.783-4.921-2.394 0-4.256.731-5.586 2.194-1.286 1.463-1.929 3.37-1.929 5.719 0 2.572.621 4.633 1.862 6.185 1.286 1.507 3.17 2.261 5.653 2.261 1.685 0 3.148-.443 4.389-1.33 1.286-.887 2.084-2.195 2.394-3.924h6.251c-.133 1.907-.754 3.702-1.862 5.387-1.064 1.685-2.571 3.059-4.522 4.123-1.906 1.064-4.234 1.596-6.982 1.596ZM33.965 215v-27.332h6.317l.466 7.581c.266-1.152.776-2.305 1.53-3.458.797-1.197 1.883-2.172 3.258-2.926 1.419-.798 3.236-1.197 5.453-1.197h.997v7.581h-.997c-3.813 0-6.473.621-7.98 1.862-1.508 1.197-2.261 3.237-2.261 6.118V215h-6.783ZM67.675 215.665c-3.147 0-5.719-.665-7.714-1.995-1.95-1.374-3.413-3.103-4.389-5.187a17.412 17.412 0 0 1-1.463-6.716c-.044-2.749.466-5.188 1.53-7.316 1.108-2.172 2.66-3.856 4.655-5.053 2.04-1.242 4.433-1.863 7.182-1.863 2.438 0 4.61.533 6.517 1.597 1.95 1.064 3.502 2.571 4.655 4.521 1.152 1.907 1.75 4.168 1.795 6.784v1.729H60.56c0 2.527.62 4.477 1.862 5.851 1.241 1.33 2.948 1.996 5.12 1.996 1.685 0 3.081-.422 4.19-1.264 1.152-.842 1.84-1.951 2.061-3.325h6.584c-.31 2.882-1.552 5.32-3.724 7.315-2.173 1.951-5.165 2.926-8.978 2.926Zm-6.916-16.558H73.66c-.044-.311-.155-.799-.332-1.464-.133-.665-.421-1.352-.865-2.061-.399-.709-1.02-1.308-1.862-1.795-.842-.488-1.928-.732-3.258-.732-1.774 0-3.126.377-4.057 1.13-.886.71-1.53 1.552-1.928 2.527-.355.931-.554 1.73-.599 2.395Zm8.18-14.365h-3.06v-.864l2.993-6.65h5.72v1.197l-5.653 6.317ZM96.262 215.665c-4.079 0-6.982-1.264-8.711-3.791-1.73-2.571-2.594-5.918-2.594-10.041 0-4.3.887-7.736 2.66-10.308 1.773-2.571 4.655-3.857 8.645-3.857 1.73 0 3.17.289 4.323.865 1.197.532 2.128 1.175 2.793 1.928.709.754 1.219 1.441 1.529 2.062.31.621.488.997.532 1.13h.133V177.56h6.983V215h-5.852l-1.131-4.855h-.133c-.044.089-.244.422-.598.998-.311.576-.843 1.219-1.596 1.928-.71.71-1.641 1.33-2.793 1.862-1.153.488-2.55.732-4.19.732Zm2.195-5.719c2.527 0 4.322-.754 5.386-2.261 1.108-1.552 1.663-3.525 1.663-5.919 0-2.305-.532-4.211-1.596-5.719-1.02-1.551-2.771-2.327-5.254-2.327-1.818 0-3.258.399-4.322 1.197-1.02.754-1.73 1.751-2.128 2.992-.4 1.197-.599 2.483-.599 3.857 0 1.375.177 2.705.532 3.99.4 1.242 1.086 2.261 2.062 3.059 1.02.754 2.438 1.131 4.256 1.131ZM122.721 184.676c-1.463.044-2.438-.288-2.926-.998-.443-.753-.665-1.64-.665-2.66 0-.975.244-1.817.732-2.527.487-.709 1.441-1.064 2.859-1.064 1.375 0 2.283.355 2.727 1.064.487.71.731 1.552.731 2.527 0 1.02-.244 1.885-.731 2.594-.444.665-1.352 1.02-2.727 1.064ZM119.263 215v-27.332h6.783V215h-6.783ZM143.269 215c-2.172 0-3.813-.532-4.921-1.596-1.064-1.064-1.596-2.793-1.596-5.187v-15.761h-4.123v-4.788c1.286 0 2.283-.133 2.993-.399.709-.266 1.219-.886 1.529-1.862.31-.975.466-2.549.466-4.721h5.453v6.982h6.251v4.788h-6.251v17.224h6.384V215h-6.185ZM167 215.665c-3.104 0-5.675-.599-7.714-1.796-2.04-1.197-3.569-2.837-4.589-4.921-1.019-2.128-1.529-4.544-1.529-7.248-.045-4.079 1.086-7.426 3.391-10.042 2.35-2.66 5.83-3.99 10.441-3.99 4.477 0 7.869 1.286 10.174 3.857 2.35 2.572 3.525 5.963 3.525 10.175 0 2.616-.488 4.987-1.463 7.115-.976 2.128-2.483 3.813-4.522 5.054-2.04 1.197-4.611 1.796-7.714 1.796Zm0-5.719c1.95 0 3.436-.421 4.455-1.264 1.064-.842 1.774-1.906 2.128-3.192.355-1.33.532-2.66.532-3.99 0-1.374-.177-2.726-.532-4.056a6.028 6.028 0 0 0-2.128-3.259c-1.019-.842-2.505-1.263-4.455-1.263-1.995 0-3.525.443-4.589 1.33-1.019.842-1.729 1.928-2.128 3.258a14.966 14.966 0 0 0-.532 3.99c0 1.33.178 2.66.532 3.99a6.58 6.58 0 0 0 2.128 3.192c1.064.843 2.594 1.264 4.589 1.264ZM203.793 214v-27.332h6.318l.465 7.581c.266-1.152.776-2.305 1.53-3.458.798-1.197 1.884-2.172 3.258-2.926 1.419-.798 3.236-1.197 5.453-1.197h.998v7.581h-.998c-3.813 0-6.473.621-7.98 1.862-1.507 1.197-2.261 3.237-2.261 6.118V214h-6.783ZM235.44 214.665c-2.394 0-4.256-.466-5.586-1.397s-2.306-2.128-2.926-3.591a16.071 16.071 0 0 1-1.064-4.588c-.133-1.64-.2-3.126-.2-4.456v-13.965h6.584v13.965c0 1.375.133 2.683.399 3.924s.82 2.239 1.662 2.992c.887.754 2.217 1.131 3.99 1.131 1.729 0 3.037-.377 3.924-1.131.886-.798 1.485-1.795 1.795-2.992.311-1.197.488-2.438.532-3.724l.067-14.165h6.916V214h-5.786l-1.13-5.187h-.133c-.089.266-.311.709-.665 1.33-.355.621-.887 1.286-1.596 1.995-.665.709-1.552 1.308-2.66 1.795-1.109.488-2.483.732-4.123.732ZM256.915 214v-27.332h6.318l.465 7.581c.266-1.152.776-2.305 1.53-3.458.798-1.197 1.884-2.172 3.258-2.926 1.419-.798 3.236-1.197 5.453-1.197h.998v7.581h-.998c-3.813 0-6.473.621-7.98 1.862-1.507 1.197-2.261 3.237-2.261 6.118V214h-6.783ZM288.429 214.665c-3.769 0-6.451-1.286-8.047-3.857-1.596-2.571-2.394-5.941-2.394-10.108 0-4.212.798-7.603 2.394-10.175 1.641-2.615 4.323-3.923 8.047-3.923 2.128 0 3.812.377 5.054 1.13 1.241.71 2.172 1.508 2.793 2.394.62.887.997 1.552 1.13 1.995h.133v-5.453h6.983V214h-5.852l-1.131-4.456h-.133c-.133.399-.532 1.02-1.197 1.862-.62.798-1.574 1.552-2.859 2.261-1.242.665-2.882.998-4.921.998Zm2.793-5.719c2.482 0 4.145-.776 4.987-2.328.887-1.596 1.33-3.546 1.33-5.852 0-2.438-.443-4.411-1.33-5.918-.886-1.507-2.549-2.261-4.987-2.261-1.729 0-3.081.377-4.057 1.13-.931.754-1.596 1.752-1.995 2.993-.354 1.197-.532 2.549-.532 4.056 0 1.508.178 2.882.532 4.123.399 1.242 1.064 2.239 1.995 2.993.976.709 2.328 1.064 4.057 1.064ZM311.917 214v-37.44h6.65V214h-6.65ZM353.305 214.238c-4.079 0-6.983-1.264-8.712-3.791-1.729-2.571-2.593-5.918-2.593-10.041 0-4.301.887-7.737 2.66-10.308 1.773-2.571 4.655-3.857 8.645-3.857 1.729 0 3.17.288 4.322.865 1.197.532 2.128 1.174 2.793 1.928.71.754 1.22 1.441 1.53 2.062.31.62.488.997.532 1.13h.133v-16.093h6.982v37.44h-5.852l-1.13-4.855h-.133c-.044.089-.244.421-.599.998-.31.576-.842 1.219-1.596 1.928-.709.709-1.64 1.33-2.793 1.862-1.152.488-2.549.732-4.189.732Zm2.194-5.719c2.527 0 4.323-.754 5.387-2.261 1.108-1.552 1.662-3.525 1.662-5.919 0-2.305-.532-4.212-1.596-5.719-1.019-1.552-2.77-2.327-5.253-2.327-1.818 0-3.259.399-4.323 1.197-1.019.753-1.729 1.751-2.128 2.992-.399 1.197-.598 2.483-.598 3.857s.177 2.704.532 3.99c.399 1.241 1.086 2.261 2.061 3.059 1.02.754 2.439 1.131 4.256 1.131ZM379.764 183.248c-1.463.045-2.438-.288-2.926-.997-.443-.754-.665-1.64-.665-2.66 0-.975.244-1.818.732-2.527.487-.709 1.441-1.064 2.859-1.064 1.375 0 2.283.355 2.727 1.064.487.709.731 1.552.731 2.527 0 1.02-.244 1.884-.731 2.593-.444.665-1.352 1.02-2.727 1.064Zm-3.458 30.325v-27.332h6.783v27.332h-6.783ZM397.657 225.742v-6.384h11.97v-10.64h-.133c-.044.089-.244.421-.598.998-.311.576-.82 1.219-1.53 1.928-.709.709-1.64 1.33-2.793 1.862-1.108.488-2.505.732-4.189.732-4.035 0-6.938-1.286-8.712-3.857-1.773-2.572-2.66-5.919-2.66-10.042 0-4.3.887-7.714 2.66-10.241 1.818-2.571 4.722-3.857 8.712-3.857 1.773 0 3.236.288 4.389.865 1.152.532 2.061 1.174 2.726 1.928s1.131 1.441 1.397 2.062c.31.62.487.997.532 1.13h.133l.066-5.985h6.983V215.9c0 3.635-.732 6.185-2.195 7.648-1.418 1.463-3.635 2.194-6.65 2.194h-10.108Zm4.855-17.223c2.482 0 4.278-.754 5.386-2.261 1.109-1.552 1.663-3.525 1.663-5.919 0-2.305-.532-4.212-1.596-5.719-1.064-1.552-2.838-2.327-5.32-2.327-1.818 0-3.237.399-4.256 1.197-1.02.753-1.751 1.751-2.195 2.992-.399 1.197-.598 2.483-.598 3.857s.177 2.704.532 3.99c.399 1.241 1.086 2.261 2.061 3.059 1.02.754 2.461 1.131 4.323 1.131ZM426.093 183.248c-1.463.045-2.438-.288-2.926-.997-.443-.754-.665-1.64-.665-2.66 0-.975.244-1.818.732-2.527.487-.709 1.441-1.064 2.859-1.064 1.375 0 2.283.355 2.727 1.064.487.709.731 1.552.731 2.527 0 1.02-.244 1.884-.731 2.593-.444.665-1.352 1.02-2.727 1.064Zm-3.458 30.325v-27.332h6.783v27.332h-6.783ZM446.641 213.572c-2.172 0-3.813-.532-4.921-1.596-1.064-1.064-1.596-2.793-1.596-5.187v-15.76h-4.123v-4.788c1.286 0 2.283-.133 2.993-.399.709-.266 1.219-.887 1.529-1.862.31-.975.466-2.549.466-4.722h5.453v6.983h6.251v4.788h-6.251v17.223h6.384v5.32h-6.185ZM468.302 214.237c-3.768 0-6.451-1.285-8.047-3.857-1.596-2.571-2.394-5.94-2.394-10.107 0-4.212.798-7.604 2.394-10.175 1.641-2.616 4.323-3.924 8.047-3.924 2.128 0 3.813.377 5.054 1.131 1.241.709 2.172 1.507 2.793 2.394.621.887.997 1.552 1.13 1.995h.133v-5.453h6.983v27.331h-5.852l-1.131-4.455h-.133c-.133.399-.532 1.02-1.197 1.862-.62.798-1.573 1.552-2.859 2.261-1.241.665-2.882.997-4.921.997Zm2.793-5.719c2.483 0 4.145-.775 4.987-2.327.887-1.596 1.33-3.547 1.33-5.852 0-2.438-.443-4.411-1.33-5.919-.886-1.507-2.549-2.261-4.987-2.261-1.729 0-3.081.377-4.057 1.131-.931.754-1.596 1.751-1.995 2.992-.354 1.197-.532 2.55-.532 4.057 0 1.507.178 2.882.532 4.123.399 1.241 1.064 2.239 1.995 2.992.976.71 2.328 1.064 4.057 1.064ZM489.79 213.573v-37.44h6.65v37.44h-6.65Z",fill:"currentColor"})))}function Ga({color:o}){return _react2.default.createElement(qo,{color:o,viewBox:"0 0 75 99",fill:"currentColor",xmlns:"http://www.w3.org/2000/svg",role:"img"},_react2.default.createElement("title",null,"Logotipo Verde - Vers\xE3o \xEDcone"),_react2.default.createElement("path",{d:"M26.572 3.12v95.56H.735V3.12h25.837ZM70.015.144C50.09.144 33.933 16.3 33.933 36.226v3.863h4.357c19.927 0 36.082-16.155 36.082-36.082V.144h-4.357Z"}))}function ja({color:o}){return _react2.default.createElement(qo,{color:o,viewBox:"0 0 75 99",fill:"none",xmlns:"http://www.w3.org/2000/svg",role:"img"},_react2.default.createElement("title",null,"Logotipo Verde - Vers\xE3o \xEDcone"),_react2.default.createElement("path",{d:"M26.572 3.12v95.56H.735V3.12h25.837ZM70.015.144C50.09.144 33.933 16.3 33.933 36.226v3.863h4.357c19.927 0 36.082-16.155 36.082-36.082V.144h-4.357Z",stroke:"#A6DF7D",strokeWidth:"2"}))}function qa({color:o}){return _react2.default.createElement(qo,{color:o,viewBox:"0 0 497 136",fill:"currentColor",xmlns:"http://www.w3.org/2000/svg",role:"img"},_react2.default.createElement("title",null,"Logotipo Verde - Vers\xE3o simples"),_react2.default.createElement("path",{d:"M40.133 133.68.027 38.12h28.005l25.473 70.994-5.779 1.079L74.46 38.109h27.46l-42.092 95.56H40.133v.011ZM156.649 135.485c-10.357 0-19.423-2.108-27.188-6.323-7.765-4.216-13.795-9.994-18.061-17.346-4.276-7.341-6.414-15.711-6.414-25.11 0-7.462 1.2-14.3 3.61-20.502 2.411-6.201 5.779-11.526 10.115-15.983 4.336-4.458 9.479-7.917 15.449-10.387 5.96-2.471 12.495-3.701 19.605-3.701 6.504 0 12.494 1.17 17.97 3.52 5.476 2.349 10.236 5.657 14.27 9.932 4.033 4.276 7.139 9.308 9.308 15.087 2.168 5.778 3.186 12.101 3.075 18.969l-.181 7.946h-76.783l-4.155-15.893h59.791l-3.076 3.247V75.15c-.242-3.368-1.291-6.323-3.157-8.854-1.865-2.531-4.245-4.548-7.139-6.05-2.895-1.503-6.081-2.26-9.57-2.26-5.416 0-9.964 1.06-13.635 3.157-3.67 2.108-6.444 5.123-8.309 9.036-1.866 3.913-2.804 8.763-2.804 14.541 0 5.779 1.2 10.63 3.611 14.905 2.41 4.276 5.869 7.564 10.387 9.843 4.517 2.289 9.842 3.428 15.983 3.428 4.216 0 8.068-.665 11.557-1.986 3.489-1.321 7.281-3.61 11.386-6.868l12.101 17.164c-3.368 3.015-7.17 5.597-11.385 7.765a58.977 58.977 0 0 1-13.009 4.881c-4.458 1.079-8.915 1.624-13.372 1.624l.02.01ZM240.572 38.12v95.56h-25.837V38.12h25.837ZM333.006 135.485c-8.31 0-15.803-2.108-22.489-6.323-6.686-4.216-11.919-10.085-15.721-17.618-3.792-7.523-5.688-16.044-5.688-25.564s1.896-18.182 5.688-25.655c3.791-7.462 9.005-13.372 15.631-17.708 6.625-4.336 14.148-6.505 22.579-6.505 4.457 0 8.763.696 12.918 2.078 4.155 1.381 7.856 3.287 11.113 5.688 3.247 2.41 5.899 5.092 7.946 8.037 2.048 2.955 3.248 5.99 3.611 9.126l-6.505 1.26V0h25.474v133.68H363.36l-1.079-22.035 5.062.726c-.121 2.894-1.149 5.718-3.075 8.491-1.927 2.773-4.488 5.274-7.675 7.493-3.197 2.229-6.807 3.973-10.841 5.234-4.033 1.26-8.279 1.896-12.736 1.896h-.01Zm5.597-21.319c4.941 0 9.186-1.2 12.736-3.61 3.55-2.41 6.353-5.718 8.401-9.933 2.047-4.216 3.075-9.097 3.075-14.633s-1.028-10.629-3.075-14.905c-2.048-4.275-4.851-7.583-8.401-9.933-3.55-2.35-7.795-3.52-12.736-3.52-4.942 0-8.855 1.17-12.465 3.52-3.61 2.35-6.414 5.657-8.4 9.933-1.987 4.276-2.985 9.248-2.985 14.905s.998 10.417 2.985 14.633c1.986 4.215 4.79 7.523 8.4 9.933 3.61 2.41 7.765 3.61 12.465 3.61ZM455.048 135.485c-10.357 0-19.423-2.108-27.188-6.323-7.765-4.216-13.795-9.994-18.061-17.346-4.276-7.341-6.414-15.711-6.414-25.11 0-7.462 1.2-14.3 3.61-20.502 2.411-6.201 5.779-11.526 10.115-15.983 4.336-4.458 9.479-7.917 15.449-10.387 5.96-2.471 12.495-3.701 19.605-3.701 6.504 0 12.494 1.17 17.97 3.52 5.476 2.349 10.236 5.657 14.27 9.932 4.033 4.276 7.139 9.308 9.308 15.087 2.168 5.778 3.186 12.101 3.075 18.969l-.181 7.946h-76.773l-4.155-15.893h59.791l-3.076 3.247V75.15c-.242-3.368-1.291-6.323-3.156-8.854-1.866-2.531-4.246-4.548-7.14-6.05-2.894-1.503-6.081-2.26-9.57-2.26-5.416 0-9.964 1.06-13.635 3.157-3.67 2.108-6.443 5.123-8.309 9.036-1.866 3.913-2.804 8.763-2.804 14.541 0 5.779 1.2 10.63 3.611 14.905 2.41 4.276 5.869 7.564 10.387 9.843 4.517 2.289 9.842 3.428 15.983 3.428 4.216 0 8.068-.665 11.557-1.986 3.489-1.321 7.281-3.61 11.386-6.868l12.101 17.164c-3.368 3.015-7.17 5.597-11.385 7.765a58.977 58.977 0 0 1-13.009 4.881c-4.458 1.079-8.915 1.624-13.372 1.624l.01.01ZM284.015 35.144c-19.926 0-36.082 16.156-36.082 36.083v3.862h4.357c19.927 0 36.082-16.155 36.082-36.082v-3.863h-4.357Z"}))}function H4({color:o="green",variant:r="simple"}){switch(r){case"full":return _react2.default.createElement(Za,null);case"minimal":return _react2.default.createElement(Ga,{color:o});case"simple":return _react2.default.createElement(qa,{color:o});case"outline":return _react2.default.createElement(ja,{color:o})}}var Xa=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    transform: translateY(1px);

    display: inline-flex;
    align-items: center;
    gap: ${o.space.xsm};

    svg {
      width: ${o.font.size.lg};
      height: ${o.font.size.lg};
    }
  `}
`,Ua=_styledcomponents2.default.button`
  ${({theme:o})=>_styledcomponents.css`
    all: unset;

    cursor: pointer;
    color: ${o.font.color.light};
    transition: 0.15s;

    &:hover {
      color: ${o.font.color.main};
    }
  `}
`,Ya=_styledcomponents2.default.div`
  ${({theme:o})=>_styledcomponents.css`
    display: flex;

    gap: ${o.space.xsm};
  `}
`;function U4({children:o,copyText:r}){let[e,t]=_react.useState.call(void 0, !1),n=!!o,i=!!n;function l(p){return ur(this,null,function*(){p.stopPropagation(),!e&&_utils.copyToClipboard.call(void 0, r).then(()=>{t(!0)})})}return _react.useEffect.call(void 0, ()=>{e&&setTimeout(()=>{t(!1)},3e3)},[e]),_react2.default.createElement(Ya,null,o,i&&_react2.default.createElement(Xa,null,n&&_react2.default.createElement(Ua,{onClick:l},e?_react2.default.createElement(_solid3.Square2StackIcon,null):_react2.default.createElement(_outline.Square2StackIcon,null))))}exports.Accordion = N1; exports.AccordionContent = mg; exports.AccordionHeader = sg; exports.AccordionItem = R1; exports.Alert = wg; exports.AlertDialog = _g; exports.AlertDialogRenderer = Ng; exports.AlertTitle = Tg; exports.Attachment = Yg; exports.Avatar = tf; exports.Backdrop = ie; exports.Badge = an; exports.Box = x; exports.Breadcrumb = pn; exports.Button = j; exports.Card = X; exports.CardHeader = e0; exports.Chip = $n; exports.Copyable = U4; exports.DataTable = or; exports.DatePicker = d2; exports.Divider = z0; exports.Drawer = O0; exports.DrawerBody = G0; exports.DrawerContent = X0; exports.DrawerFooter = Q0; exports.DrawerHeader = R0; exports.Dropzone = xu; exports.Fieldset = vu; exports.FileCard = Pe; exports.FloatingBar = yp; exports.FormControl = Qu; exports.FormHelperText = y2; exports.FormLabel = Q2; exports.Header = r3; exports.Icon = h3; exports.IconButton = q; exports.InfoItem = W3; exports.Input = Ir; exports.InputMask = _2; exports.InputMaskHelpers = O2; exports.InputMaskOptions = W2; exports.Logo = H4; exports.Menu = J3; exports.Modal = oe; exports.ModalBody = re; exports.ModalContent = ee; exports.ModalFooter = te; exports.ModalHeader = ne; exports.NavigationMenu = Ai; exports.Option = ix; exports.Paginator = _r; exports.PreviewCard = U5; exports.Progress = qn; exports.Rating = lb; exports.Select = In; exports.Skeleton = xb; exports.Spinner = so; exports.Step = _b; exports.StepLabel = qb; exports.Stepper = Mb; exports.Table = Tn; exports.TableBody = Bn; exports.TableCell = Se; exports.TableContainer = Mn; exports.TableEmpty = Dn; exports.TableFooter = zn; exports.TableHead = An; exports.TableHeading = Fn; exports.TableRow = $e; exports.TableSortLabel = Ln; exports.Tabs = n4; exports.Textarea = zx; exports.ThemeProvider = Om; exports.Tooltip = ri; exports.Typography = v; exports.cssHelpers = M1; exports.theme = J; exports.useAccordionContext = Wt; exports.useAccordionItemContext = No; exports.useFormControl = O; exports.useOutsideClick = yt; exports.usePreventBodyScroll = xr; exports.useStepperContext = va; exports.useStepperItemContext = Zr;
//# sourceMappingURL=index.js.map